export default {
  translation: {
    // Common
    "app.name": "Give Protocol",
    "app.tagline": "투명하고 국경 없는 나눔의 인프라.",
    "common.skipToMainContent": "주요 내용으로 건너뛰기",
    "common.cancel": "취소",
    "common.edit": "편집",
    "common.delete": "삭제",
    "common.creating": "생성 중...",
    "common.unknown": "알 수 없음",
    "common.notAvailable": "해당 없음",

    // Navigation
    "nav.browse": "자선단체 찾기",
    "nav.opportunities": "봉사 기회",
    "nav.contributions": "기여 추적기",
    "nav.governance": "거버넌스",
    "nav.dashboard": "Give 대시보드",
    "nav.about": "소개",
    "nav.docs": "문서",
    "nav.legal": "법적 정보",
    "nav.launchApp": "앱 실행",

    // FAQ page (GIV-988)
    "faq.title": "자주 묻는 질문",
    "faq.subtitle": "기부, 자원봉사, 블록체인 투명성에 대해 알아야 할 모든 것.",

    // Settings
    "settings.title": "설정",
    "settings.language": "언어",
    "settings.currency": "통화",

    // Auth
    "auth.login": "로그인",
    "auth.register": "계정 만들기",
    "auth.logout": "로그아웃",
    "auth.forgotPassword": "비밀번호를 잊으셨나요?",

    // Dashboard
    "dashboard.title": "Give 대시보드",
    "dashboard.subtitle": "기부 및 봉사 기여를 추적하세요",
    "dashboard.totalDonations": "총 기부액",
    "dashboard.volunteerHours": "봉사 시간",
    "dashboard.skillsEndorsed": "인증된 기술",
    "dashboard.contributions": "기여",
    "dashboard.yourTotalDonated": "나의 총 기부액",
    "dashboard.yourVolunteerHours": "나의 봉사 시간",
    "dashboard.yourSkillsEndorsed": "나의 인증된 기술",
    "dashboard.impactGrowth": "영향력 성장",
    "dashboard.charitiesSupported": "지원한 자선단체",

    // Charity
    "charity.dashboard": "자선단체 대시보드",
    "charity.subtitle": "기부 및 봉사 프로그램을 관리하세요",
    "charity.activeVolunteers": "활동 중인 봉사자",
    "charity.transactions": "거래",
    "charity.volunteers": "봉사 시간",
    "charity.applications": "신청서",
    "charity.totalReceived": "총 수령액",
    "charity.equityPoolValue": "지분 풀 가치",
    "charity.availableBalance": "가용 잔액",

    // Contributions
    "contributions.date": "날짜",
    "contributions.type": "유형",
    "contributions.organization": "단체",
    "contributions.details": "세부 정보",
    "contributions.status": "상태",
    "contributions.verification": "검증",
    "contributions.export": "CSV 내보내기",

    // Volunteer
    "volunteer.opportunities": "봉사 기회",
    "volunteer.searchOpportunities": "기회 검색...",
    "volunteer.selectSkill": "기술 선택",
    "volunteer.selectType": "유형 선택",
    "volunteer.selectLanguage": "언어 선택",
    "volunteer.allSkills": "모든 기술",
    "volunteer.allTypes": "모든 유형",
    "volunteer.allLanguages": "모든 언어",
    "volunteer.applyNow": "지금 지원하기",
    "volunteer.noOpportunitiesFound":
      "검색 조건에 맞는 기회를 찾을 수 없습니다.",
    "volunteer.verify": "시간 검증",
    "volunteer.verifying": "검증 중...",
    "volunteer.reject": "거부",
    "volunteer.accept": "수락",
    "volunteer.processing": "처리 중...",
    "volunteer.hours": "시간 -",
    "volunteer.description": "설명",
    "volunteer.appliedFor": "지원 대상",
    "volunteer.verificationComplete": "검증 완료",
    "volunteer.hoursVerified":
      "봉사 시간이 검증되어 블록체인에 기록되었습니다.",
    "volunteer.verificationHash": "검증 해시",
    "volunteer.applicationAccepted": "신청 수락됨",
    "volunteer.applicationRecorded":
      "봉사 신청이 수락되어 블록체인에 기록되었습니다.",
    "volunteer.acceptanceHash": "수락 해시",
    "volunteer.pendingHours": "대기 중인 봉사 시간",
    "volunteer.noPendingHours": "검증할 대기 중인 봉사 시간이 없습니다.",
    "volunteer.pendingApplications": "대기 중인 신청서",
    "volunteer.noPendingApplications": "검토할 대기 중인 신청서가 없습니다.",
    "volunteer.createOpportunity": "봉사 기회 만들기",
    "volunteer.createNew": "새로 만들기",
    "volunteer.noOpportunitiesYet":
      '아직 생성된 기회가 없습니다. "새로 만들기"를 클릭하여 시작하세요.',
    "volunteer.opportunityTitle": "기회 제목",
    "volunteer.skills": "기술 (쉼표로 구분)",
    "volunteer.commitment": "참여 기간",
    "volunteer.location": "위치",
    "volunteer.type": "유형",
    "volunteer.workLanguage": "사용 언어",
    "volunteer.status": "상태",

    // Volunteer commitment types
    "volunteer.commitment.oneTime": "일회성",
    "volunteer.commitment.shortTerm": "단기",
    "volunteer.commitment.longTerm": "장기",

    // Volunteer types
    "volunteer.type.remote": "원격",
    "volunteer.type.onsite": "현장",
    "volunteer.type.hybrid": "혼합",
    "volunteer.type.onSite": "현장",

    // Volunteer - Opportunities page
    "volunteer.workTypeFilter": "근무 유형 필터",
    "volunteer.searchLocation": "도시 또는 지역...",
    "volunteer.searchLocationAria": "위치 검색",
    "volunteer.filter.skill": "기술: {{value}}",
    "volunteer.filter.type": "유형: {{value}}",
    "volunteer.filter.language": "언어: {{value}}",
    "volunteer.filter.location": "위치: {{value}}",
    "volunteer.loadingOpportunities": "기회를 불러오는 중...",
    "volunteer.loadOpportunitiesError": "봉사 기회를 불러올 수 없습니다. 나중에 다시 시도해 주세요.",
    "volunteer.viewDetails": "상세 보기",
    "volunteer.backToOpportunities": "기회 목록으로 돌아가기",
    "volunteer.detail.about": "이 기회에 대하여",
    "volunteer.detail.skills": "필요한 기술",
    "volunteer.detail.commitment": "시간 약속",
    "volunteer.detail.location": "위치",
    "volunteer.detail.language": "언어",
    "volunteer.detail.hostedBy": "주최",
    "volunteer.detail.ongoing": "상시 진행",
    "volunteer.detail.applicationsClosed": "지원 마감",
    "volunteer.detail.notFoundTitle": "기회를 찾을 수 없습니다",
    "volunteer.detail.notFoundMessage": "이 기회는 마감되었거나 삭제되었을 수 있습니다.",
    "volunteer.field.requirements": "요건",
    "volunteer.field.benefits": "혜택",
    "volunteer.field.schedule": "일정",
    "volunteer.field.schedulePlaceholder": "예: 화요일 오후 6-8시, 주말 유연",
    "volunteer.field.startDate": "시작일",
    "volunteer.field.endDate": "종료일",
    "volunteer.field.endDateHelp": "상시 진행이면 비워 두세요",
    "volunteer.field.applicationDeadline": "지원 마감일",
    "volunteer.field.volunteersNeeded": "필요한 봉사자 수",
    "volunteer.field.minimumAge": "최소 연령",
    "volunteer.field.backgroundCheckRequired": "신원 조회 필요",
    "volunteer.field.trainingProvided": "교육 제공",
    "volunteer.field.onePerLine": "한 줄에 하나씩",
    "volunteer.validation.volunteersNeeded": "1 이상의 숫자를 입력하세요",
    "volunteer.validation.minimumAge": "0에서 120 사이의 나이를 입력하세요",
    "volunteer.validation.endDate": "종료일은 시작일과 같거나 이후여야 합니다",
    "volunteer.signInToApply": "봉사 기회에 지원하려면 로그인해 주세요",
    "volunteer.applicationSuccess": "신청이 성공적으로 제출되었습니다!",
    "volunteer.removeFilter": "{{filter}} 필터 제거",

    // Volunteer - OpportunityForm
    "volunteer.validation.titleRequired": "제목은 필수입니다",
    "volunteer.validation.descriptionRequired": "설명은 필수입니다",
    "volunteer.validation.skillsRequired": "최소 하나의 기술이 필요합니다",
    "volunteer.validation.locationRequired": "위치는 필수입니다",
    "volunteer.profileNotFound": "사용자 프로필을 찾을 수 없습니다",
    "volunteer.correctErrors": "유효성 검사 오류를 수정해 주세요",
    "volunteer.createFailed": "기회 생성에 실패했습니다",
    "volunteer.descriptionPlaceholder":
      "봉사 기회에 대해 자세히 설명해 주세요...",
    "volunteer.skillsPlaceholder": "예: 웹 개발, 프로젝트 관리, 번역",
    "volunteer.locationPlaceholder": "예: 원격, 서울, 부산",
    "volunteer.headerImage": "헤더 이미지",
    "volunteer.headerImageHelp":
      "봉사 기회 목록 상단에 표시할 이미지를 업로드하세요",
    "volunteer.limitReached": "기회 생성 한도 도달",
    "volunteer.limitReachedMessage":
      "활성 봉사 기회의 최대 수 {{max}}개에 도달했습니다. 새 기회를 만들기 전에 기존 기회를 종료하거나 완료해 주세요.",
    "volunteer.opportunityCount":
      "활성 기회 {{count}}개 / 최대 {{max}}개를 사용 중입니다.",

    // Volunteer - HoursVerificationTab
    "volunteer.hoursVerification": "시간 검증",
    "volunteer.hoursVerificationDescription":
      "봉사 시간 제출을 검토하고 검증하세요",
    "volunteer.formalHours": "기록된 시간",
    "volunteer.selfReported": "자체 보고",
    "volunteer.loggedHours": "기록된 봉사 시간",
    "volunteer.loggedHoursDescription": "봉사자가 기회를 통해 기록한 시간",
    "volunteer.allCaughtUp": "모두 처리 완료!",
    "volunteer.noPendingLoggedHours": "검증할 대기 중인 기록 시간이 없습니다.",
    "volunteer.selfReportedHours": "자체 보고 시간",

    // Volunteer - OpportunitiesTab
    "volunteer.noOpportunitiesTitle": "아직 기회가 없습니다",
    "volunteer.activeCount": "활성 기회 {{count}}개 / 최대 {{max}}개",
    "volunteer.moreSkills": "+{{count}}개 더",

    // Volunteer - ApplicationsTab
    "volunteer.noApplications": "대기 중인 신청서가 없습니다",
    "volunteer.unknownOpportunity": "알 수 없는 기회",

    // Volunteer - VerificationLookup
    "volunteer.verifyContribution": "봉사 기여 검증",
    "volunteer.hashPlaceholder": "검증 해시를 입력하세요",
    "volunteer.searching": "검색 중...",
    "volunteer.verifyHash": "해시 검증",
    "volunteer.verificationNotFound": "검증 결과를 찾을 수 없습니다",
    "volunteer.verificationNotFoundMessage":
      "입력하신 해시를 기록에서 찾을 수 없습니다. 해시를 확인하고 다시 시도해 주세요.",
    "volunteer.unknownOrganization": "알 수 없는 단체",

    // Volunteer - VolunteerVerificationCard
    "volunteer.contributionVerification": "봉사 기여 검증",
    "volunteer.volunteerLabel": "봉사자",
    "volunteer.opportunityLabel": "기회",
    "volunteer.organizationLabel": "단체",
    "volunteer.acceptedOn": "수락일",
    "volunteer.verifiedOn": "검증일",
    "volunteer.verificationHashes": "검증 해시",
    "volunteer.blockchainReference": "블록체인 참조",

    // Volunteer - VerifyContribution page
    "volunteer.verifyingContribution": "기여 검증 중\u2026",
    "volunteer.noHashProvided": "검증 해시가 제공되지 않았습니다.",
    "volunteer.verificationSuccessful": "검증 성공",
    "volunteer.contributionVerifiedBlockchain":
      "이 봉사 기여는 검증되어 블록체인에 기록되었습니다.",
    "volunteer.verificationFailed": "검증 실패",
    "volunteer.hashNotFound":
      "검증 해시 {{hash}}를 찾을 수 없거나 유효하지 않습니다.",

    // Volunteer - SelfReportedHoursDashboard
    "volunteer.volunteerHoursTitle": "봉사 시간",
    "volunteer.aboutSelfReported": "자체 보고 시간 안내",
    "volunteer.selfReportedInfo":
      "인증된 단체에서 검증한 시간만 글로벌 영향력 순위에 반영됩니다. 플랫폼에 등록되지 않은 단체의 시간은 추적할 수 있지만, 검증을 받을 때까지 \u201c미검증\u201d으로 표시됩니다.",
    "volunteer.logHoursButton": "시간 기록",
    "volunteer.logVolunteerHours": "봉사 시간 기록",
    "volunteer.editRecord": "기록 편집",
    "volunteer.recordDetails": "기록 세부 정보",
    "volunteer.backToList": "목록으로 돌아가기",
    "volunteer.deleteRecord": "기록을 삭제하시겠습니까?",
    "volunteer.deleteConfirmation":
      "이 봉사 시간 기록을 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.",

    // Volunteer - SelfReportedHoursForm
    "volunteer.activityType": "활동 유형",
    "volunteer.organization": "단체",
    "volunteer.searchRegistry": "등록부 검색",
    "volunteer.searchRegistryPlaceholder":
      "이름 또는 납세자 번호로 자선단체 등록부 검색…",
    "volunteer.registryTaxId": "납세자 번호 {{value}}",
    "volunteer.notListed": "목록에 없음",
    "volunteer.organizationName": "단체명",
    "volunteer.enterOrgName": "단체명을 입력하세요",
    "volunteer.contactEmail": "연락처 이메일",
    "volunteer.contactEmailOptional": "(선택 사항)",
    "volunteer.onboardHelp":
      "이 단체의 온보딩을 돕기 위해 연락드릴 수 있습니다",
    "volunteer.submittedForValidation": "이 기록은 검증을 위해 제출됩니다",
    "volunteer.submittedForValidationTo":
      "이 기록은 {{org}}에 검증을 위해 제출됩니다",
    "volunteer.validationExpired": "이 날짜에 대한 검증 기간이 만료되었습니다",
    "volunteer.savedAsUnvalidated": "이 기록은 미검증 상태로 저장됩니다",
    "volunteer.describeActivities": "수행한 활동을 설명해 주세요...",
    "volunteer.moreCharsNeeded": "{{count}}자 더 입력해 주세요",
    "volunteer.updating": "업데이트 중...",
    "volunteer.logging": "기록 중...",
    "volunteer.updateHours": "시간 업데이트",

    // Volunteer - SelfReportedHoursList
    "volunteer.statusFilter": "상태",
    "volunteer.activityTypeFilter": "활동 유형",
    "volunteer.filterFrom": "시작일",
    "volunteer.filterTo": "종료일",
    "volunteer.clearFilters": "필터 초기화",
    "volunteer.allStatuses": "전체",
    "volunteer.allActivityTypes": "모든 유형",
    "volunteer.noMatchingRecords": "일치하는 기록이 없습니다",
    "volunteer.noHoursLogged": "아직 기록된 봉사 시간이 없습니다",
    "volunteer.adjustFilters": "필터를 조정하여 기록을 찾아보세요.",
    "volunteer.startLogging": "첫 번째 봉사 시간을 기록해 보세요.",

    // Volunteer - SelfReportedHoursStats
    "volunteer.validatedHours": "검증된 시간",
    "volunteer.pendingValidation": "검증 대기 중",
    "volunteer.unvalidatedHours": "미검증 시간",
    "volunteer.rejectedLabel": "거부됨",
    "volunteer.hoursUnit": "시간",
    "volunteer.recordSingular": "건",
    "volunteer.recordPlural": "건",

    // Volunteer - VolunteerApplicationForm
    "volunteer.applicationTitle": "봉사 기회 신청서",
    "volunteer.applicationSubtitle":
      "검증된 기여를 통해 지속 가능한 영향력을 만들어 보세요",
    "volunteer.progress.info": "정보",
    "volunteer.progress.skills": "기술",
    "volunteer.progress.consent": "동의",
    "volunteer.fieldValid": "좋습니다",
    "volunteer.draftSaved": "임시 저장됨",
    "volunteer.personalInfo": "개인 정보",
    "volunteer.firstName": "이름",
    "volunteer.lastName": "성",
    "volunteer.emailAddress": "이메일 주소",
    "volunteer.phoneNumber": "전화번호",
    "volunteer.locationCity": "위치/도시",
    "volunteer.locationCityPlaceholder": "예: 서울특별시",
    "volunteer.timeZone": "시간대",
    "volunteer.selectTimeZone": "시간대 선택",
    "volunteer.ageRange": "연령대",
    "volunteer.selectAgeRange": "연령대 선택",
    "volunteer.skillsAndInterests": "기술 및 관심 분야",
    "volunteer.skillsLabel": "기술 및 관심 분야",
    "volunteer.skillPlaceholderFull":
      "기술을 입력하세요 (예: Python 프로그래밍, 발표, 보조금 작성)",
    "volunteer.skillPlaceholderShort": "기술을 입력하고 Enter를 누르세요...",
    "volunteer.commitmentLevel": "참여 수준",
    "volunteer.commitmentOneTimeDesc": "단일 프로젝트 또는 단기 작업",
    "volunteer.commitmentShortTermDesc": "몇 주에서 몇 개월",
    "volunteer.commitmentLongTermDesc": "수개월 이상의 지속적인 참여",
    "volunteer.experienceLabel": "관련 경험에 대해 알려주세요",
    "volunteer.experiencePlaceholder":
      "Give Protocol에서 봉사하고자 하는 동기와 배경, 기술에 대해 설명해 주세요...",
    "volunteer.consentTitle": "동의 및 약관",
    "volunteer.consentHeader": "봉사 신청 동의서",
    "volunteer.submitting": "제출 중...",
    "volunteer.submitApplication": "봉사 신청서 제출",
    "volunteer.disclaimerText":
      "이 신청서를 제출함으로써, Give Protocol의 개인정보 처리방침과 봉사 가이드라인을 읽고 이해했음을 인정합니다. 귀하의 데이터는 관련 데이터 보호 규정에 따라 처리됩니다.",
    "volunteer.validation.firstNameInvalid": "유효한 이름을 입력해 주세요",
    "volunteer.validation.lastNameInvalid": "유효한 성을 입력해 주세요",
    "volunteer.validation.emailInvalid": "유효한 이메일 주소를 입력해 주세요",
    "volunteer.validation.phoneInvalid": "유효한 전화번호를 입력해 주세요",
    "volunteer.validation.experienceRequired": "관련 경험을 설명해 주세요",
    "volunteer.validation.addSkill": "최소 하나의 기술을 추가해 주세요",
    "volunteer.validation.ageRangeRequired": "연령대를 선택해 주세요",
    "volunteer.validation.consentRequired":
      "모든 필수 동의 항목에 동의해야 합니다",
    "volunteer.signInToSubmit": "신청서를 제출하려면 로그인해 주세요",
    "volunteer.submitFailed": "신청서 제출에 실패했습니다. 다시 시도해 주세요.",

    // Volunteer - ApplicationForm
    "volunteer.applyForTitle": "지원: {{title}}",
    "volunteer.fullName": "성명 *",
    "volunteer.phoneRequired": "전화번호 *",
    "volunteer.emailRequired": "이메일 주소 *",
    "volunteer.dateOfBirth": "생년월일",
    "volunteer.availabilityTitle": "가능 시간",
    "volunteer.preferredDays": "선호 요일",
    "volunteer.preferredTimes": "선호 시간대",
    "volunteer.commitmentLevelLabel": "참여 수준",
    "volunteer.skillsAndExperience": "기술 및 경험",
    "volunteer.relevantExperience": "관련 경험 *",
    "volunteer.certifications": "자격증 (쉼표로 구분)",
    "volunteer.interestsAndPreferences": "관심 분야 및 선호도",
    "volunteer.areasOfInterest": "관심 분야 (쉼표로 구분)",
    "volunteer.referencesTitle": "추천인",
    "volunteer.referenceName": "추천인 {{index}} 이름",
    "volunteer.referenceContact": "추천인 {{index}} 연락처",
    "volunteer.workSamplesTitle": "작업 샘플",
    "volunteer.workSamplesLabel": "작업 샘플 링크 (쉼표로 구분)",
    "volunteer.submitApplicationShort": "신청서 제출",
    "volunteer.validation.nameInvalid": "유효한 이름을 입력해 주세요 (2~100자)",
    "volunteer.validation.provideExperience":
      "경험에 대한 정보를 제공해 주세요",
    "volunteer.validation.selectDay": "최소 하루를 선택해 주세요",
    "volunteer.validation.selectTime": "최소 한 시간대를 선택해 주세요",

    // Volunteer - ConsentForm
    "volunteer.consentUnderstand": "다음 사항을 이해합니다:",
    "volunteer.processingAckTitle": "처리 확인",
    "volunteer.processingAckDesc": "계속하기 전에 다음 사항을 확인해 주세요:",
    "volunteer.essentialProcessingTitle": "신청 처리 (확인 필요):",
    "volunteer.acknowledgmentTitle": "확인",
    "volunteer.ageConfirmationTitle": "연령 확인:",
    "volunteer.privacyNoticeTitle": "개인정보 처리방침:",
    "volunteer.doNotAccept": "동의하지 않음",
    "volunteer.acceptAndContinue": "동의하고 계속하기",
    "volunteer.validation.essentialRequired":
      "계속하려면 신청 처리 확인을 완료해야 합니다",
    "volunteer.validation.agePrivacyRequired":
      "연령을 확인하고 개인정보 처리방침을 읽었음을 확인해야 합니다",

    // Age affirmation gate (shared across all surfaces — GIV-453)
    "ageGate.positive": "본인은 만 16세 이상임을 확인합니다.",
    "ageGate.negative":
      "Give Protocol은 만 16세 이상의 사용자가 이용할 수 있습니다. 만 16세 미만인 경우 현재 요청을 처리할 수 없습니다.",

    // Languages
    "language.english": "영어",
    "language.spanish": "스페인어",
    "language.german": "독일어",
    "language.french": "프랑스어",
    "language.japanese": "일본어",
    "language.chinese_simplified": "중국어 (간체)",
    "language.chinese_traditional": "중국어 (번체)",
    "language.thai": "태국어",
    "language.vietnamese": "베트남어",
    "language.korean": "한국어",
    "language.arabic": "아랍어",
    "language.hindi": "힌디어",
    "language.multiple": "다국어",

    // Contribution types
    "contribution.type.donation": "기부",
    "contribution.type.volunteerapplication": "봉사 신청",
    "contribution.type.volunteerhours": "봉사 시간",
    "contribution.type.volunteeracceptance": "봉사 수락",
    "contribution.type.volunteerverification": "봉사 검증",

    // Donor/Volunteer
    "donor.volunteer": "기부자/봉사자",
    "donor.anonymous": "익명",
    "volunteer.unknown": "알 수 없는 봉사자",

    // Statuses
    "status.completed": "완료됨",
    "status.pending": "대기 중",
    "status.failed": "실패",

    // Blockchain
    "blockchain.block": "블록",

    // Filter
    "filter.allYears": "전체 연도",
    "filter.allTypes": "모든 유형",
    "filter.donations": "기부",
    "filter.volunteerApplications": "봉사 신청",
    "filter.volunteerHours": "봉사 시간",
    "filter.fiatDonations": "법정화폐 기부",

    // Export
    "export.title": "기여 데이터 내보내기",
    "export.filename": "파일 이름",
    "export.dateRange": "날짜 범위",
    "export.includePersonal": "지갑 주소 포함",
    "export.willInclude": "내보내기에 포함될 항목:",
    "export.walletAddresses": "지갑 주소 (발신자 및 수신자)",
    "export.volunteerDetails": "봉사 기여 세부 정보 (해당되는 경우)",
    "export.verificationHashes": "검증 해시 (해당되는 경우)",
    "export.cancel": "취소",
    "export.download": "CSV 내보내기",

    // Skills
    "skills.endorsements": "기술 및 추천",

    // Home
    "home.subtitle": "가장 필요한 곳에 자원을 연결합니다",
    "home.startDonating": "기부 시작하기",

    // Modal - shared
    "modal.close": "모달 닫기",
    "modal.closeAriaLabel": "닫기",

    // Modal - wallet connection
    "modal.wallet.title": "지갑 연결",
    "modal.wallet.description":
      "Give Protocol의 모든 기능을 사용하려면 지갑을 연결하세요",
    "modal.wallet.benefit1": "블록체인에서 기부 내역을 투명하게 추적하세요",
    "modal.wallet.benefit2": "기여에 대한 보상으로 GIVE 토큰을 받으세요",
    "modal.wallet.benefit3": "프로토콜 거버넌스 의사결정에 참여하세요",
    "modal.wallet.connecting": "연결 중...",
    "modal.wallet.clickToConnect": "클릭하여 연결",
    "modal.wallet.noExtension": "지갑 확장 프로그램이 감지되지 않았습니다.",
    "modal.wallet.installMetaMask": "MetaMask를 설치하여 시작하세요",
    "modal.wallet.skip": "나중에 하기",
    "modal.wallet.footerNote":
      "내비게이션 바에서 언제든지 지갑을 연결할 수 있습니다",
    "modal.wallet.failedConnect": "지갑 연결에 실패했습니다",

    // Modal - wallet link
    "modal.walletLink.title": "지갑 연동",
    "modal.walletLink.description":
      "온체인 기부, 토큰 보상, 거버넌스를 위해 계정에 지갑을 연동하세요",
    "modal.walletLink.benefit1":
      "인증된 자선단체에 직접 온체인으로 암호화폐를 기부하세요",
    "modal.walletLink.benefit2Pre": "기여에 대한",
    "modal.walletLink.benefit2Post": "자격 증명을 획득하세요",
    "modal.walletLink.benefit3": "이메일 또는 지갑으로 로그인 — 동일한 계정",
    "modal.walletLink.buttonLinking": "연동 중\u2026",
    "modal.walletLink.buttonLink": "지갑 연동",
    "modal.walletLink.buttonConnectFirst": "먼저 지갑을 연결하세요",
    "modal.walletLink.footerNote":
      "설정에서 언제든지 지갑을 연동할 수 있습니다",
    "modal.walletLink.failedLink": "지갑 연동에 실패했습니다",

    // Modal - chain selection
    "modal.chain.title": "Give Protocol에 오신 것을 환영합니다",
    "modal.chain.subtitle": "시작하려면 원하시는 네트워크를 선택하세요",
    "modal.chain.footerNote": "메뉴에서 언제든지 네트워크를 전환할 수 있습니다",
    "modal.chain.connecting": "연결 중...",
    "modal.chain.continue": "계속하기",
    "modal.chain.failedSelect": "네트워크 선택에 실패했습니다",

    // Modal - network selection (WalletModal step 1)
    "modal.network.title": "네트워크 선택",
    "modal.network.nextStep": "다음 단계: 지갑 연결",
    "modal.network.learnMore": "네트워크 선택에 대해 자세히 알아보기",

    // Modal - wallet connect (WalletModal step 2)
    "modal.connect.title": "지갑 연결",
    "modal.connect.backAria": "네트워크 선택으로 돌아가기",
    "modal.connect.noWallets":
      "{{chainType}} 체인에 사용 가능한 지갑이 없습니다.",
    "modal.connect.tryDifferentChain": "다른 체인 유형을 선택해 보세요.",
    "modal.connect.viewOtherWallets": "지원되는 다른 지갑 보기",
    "modal.connect.termsAgreement": "연결함으로써 당사의",
    "modal.connect.termsLink": "이용약관",
    "modal.connect.termsPrivacyConnector": "및",
    "modal.connect.privacyLink": "개인정보 처리방침",
    "modal.connect.chainTypeAria": "체인 유형",
    "modal.connect.failedConnect": "연결에 실패했습니다",

    // Modal - donation
    "modal.donation.successTitle": "감사합니다!",
    "modal.donation.donationProcessedOneTime":
      "{{charityName}}에 대한 {{amount}} 기부가 처리되었습니다.",
    "modal.donation.donationProcessedRecurring":
      "{{charityName}}에 대한 월 {{amount}} 기부가 처리되었습니다.",
    "modal.donation.recurringNote": "취소하실 때까지 매월 결제됩니다.",
    "modal.donation.receiptNote": "영수증이 이메일로 발송되었습니다.",
    "modal.donation.done": "완료",
    "modal.donation.errorTitle": "문제가 발생했습니다",
    "modal.donation.errorDefault":
      "예기치 않은 오류가 발생했습니다. 다시 시도해 주세요.",
    "modal.donation.tryAgain": "다시 시도",
    "modal.donation.close": "닫기",
    "modal.donation.amountLabel": "기부 금액",
    "modal.donation.perMonth": "월",
    "modal.donation.monthly": "월간",
    "modal.donation.oneTime": "일회성",
    "modal.donation.loadingPaymentForm": "결제 양식 로딩 중...",
    "modal.donation.supportMonthly": "{{charityName}} 월간 후원하기",
    "modal.donation.donateToCharity": "{{charityName}}에 기부하기",

    // Modal - scheduled donation
    "modal.scheduledDonation.title": "{{charityName}}에 월간 기부 예약",

    // Modal - withdrawal
    "modal.withdrawal.title": "출금 요청",

    // Modal - validation response
    "modal.validation.rejectTitle": "검증 요청 거부",
    "modal.validation.reviewTitle": "검증 요청 검토",
    "modal.validation.volunteer": "봉사자",
    "modal.validation.activityDetails": "활동 세부 정보",
    "modal.validation.date": "날짜",
    "modal.validation.hour": "시간",
    "modal.validation.hours": "시간",
    "modal.validation.activityType": "활동 유형",
    "modal.validation.location": "위치",
    "modal.validation.description": "설명",
    "modal.validation.submitted": "제출일:",
    "modal.validation.daysRemaining": "(검증까지 {{count}}일 남음)",
    "modal.validation.appealNote":
      "이전에 거부된 요청의 이의 제기/재제출입니다",
    "modal.validation.rejectPrompt":
      "이 검증 요청을 거부하는 사유를 선택해 주세요. 봉사자에게 통지됩니다.",
    "modal.validation.reject": "거부",
    "modal.validation.approve": "승인",
    "modal.validation.processing": "처리 중...",
    "modal.validation.back": "뒤로",
    "modal.validation.confirmRejection": "거부 확인",
    "modal.validation.selectReasonError": "거부 사유를 선택해 주세요",

    // Toast
    "toast.dismiss": "알림 닫기",

    // Error boundary
    "error.somethingWrong": "문제가 발생했습니다",
    "error.unexpectedError": "예기치 않은 오류가 발생했습니다",
    "error.tryAgain": "다시 시도",
    "error.tooManyAttempts": "시도 횟수가 너무 많습니다",
    "error.goHome": "홈페이지로 이동",
    "error.details": "오류 세부 정보",

    // Validation - rejection reason select
    "validation.rejection.reasonLabel": "거부 사유",
    "validation.rejection.reasonPlaceholder": "사유를 선택하세요...",
    "validation.rejection.notesLabel": "추가 메모",
    "validation.rejection.optional": "(선택 사항)",
    "validation.rejection.notesPlaceholder":
      "거부에 대한 추가 설명을 입력해 주세요...",

    // Validation - batch actions
    "validation.batch.deselectAll": "전체 선택 해제",
    "validation.batch.selectAll": "전체 선택",
    "validation.batch.selected": "{{total}}개 중 {{selected}}개 선택됨",
    "validation.batch.clear": "초기화",
    "validation.batch.reject": "거부 ({{count}})",
    "validation.batch.approve": "승인 ({{count}})",

    // Dashboard - admin redirect (GIV-254)
    "dashboard.adminTitle": "관리자 대시보드",
    "dashboard.adminNote": "플랫폼을 관리하려면 관리자 패널을 사용해 주세요.",
    "dashboard.adminButton": "관리자 패널로 이동",
    "dashboard.logVolunteerHours": "봉사 시간 기록",
    "dashboard.hideVolunteerHours": "봉사 시간 숨기기",
    "dashboard.viewMonthlyDonations": "월간 기부 보기",
    "dashboard.hideMonthlyDonations": "월간 기부 숨기기",
    "dashboard.walletSettings": "지갑 설정",
    "dashboard.overview": "개요",
    "dashboard.lastUpdated": "최종 업데이트",
    "dashboard.refreshData": "데이터 새로고침",
    "dashboard.searchPlaceholder": "프로젝트, 봉사자 검색 (Cmd+K)",
    "dashboard.search": "검색",

    // Settings - account section (GIV-254)
    "settings.manageDescription": "계정 및 환경 설정을 관리하세요",
    "settings.account": "계정",
    "settings.email": "이메일",
    "settings.displayName": "표시 이름",
    "settings.authMethod": "인증 방식",
    "settings.role": "역할",

    // Common additional (GIV-254)
    "common.refresh": "새로고침",
    "common.all": "전체",
    "common.loading": "로딩 중...",
    "common.close": "닫기",
    "common.back": "뒤로",

    // Cause (GIV-254)
    "cause.createCause": "캠페인 만들기",

    // Contribution Tracker (GIV-254)
    "tracker.title": "글로벌 영향력 순위",
    "tracker.subtitle": "커뮤니티의 집단적 영향력을 추적하고 축하하세요",
    "tracker.searchPlaceholder": "기여자 검색...",
    "tracker.exportCSV": "CSV 내보내기",
    "tracker.exportPDF": "PDF 내보내기",
    "tracker.hideContributions": "순위에서 내 기여 숨기기",
    "tracker.yourAlias": "나의 별칭:",
    "tracker.changeAlias": "변경",
    "tracker.setWalletAlias": "지갑 별칭 설정",
    "tracker.aliasTitle": "지갑 별칭 설정",
    "tracker.aliasDescription":
      "기여 추적기에서 지갑 주소 대신 표시될 별칭입니다.",
    "tracker.aliasLabel": "별칭",
    "tracker.aliasPlaceholder": "원하시는 별칭을 입력하세요",
    "tracker.saveAlias": "별칭 저장",
    "tracker.donationRankings": "기부 순위",
    "tracker.volunteerRankings": "봉사 순위",
    "tracker.exportComplete": "내보내기 완료",
    "tracker.exportDonationCSV": "기부 순위가 CSV로 내보내기 되었습니다",
    "tracker.exportVolunteerCSV": "봉사 순위가 CSV로 내보내기 되었습니다",
    "tracker.exportPDFSuccess": "순위가 PDF로 내보내기 되었습니다",
    "tracker.exportFailed": "내보내기 실패",
    "tracker.exportNoData": "내보낼 데이터가 없습니다",
    "tracker.exportError": "데이터 내보내기 중 오류가 발생했습니다",
    "tracker.walletNotConnected": "지갑이 연결되지 않았습니다",
    "tracker.connectWalletForAlias": "별칭을 설정하려면 지갑을 연결해 주세요",
    "tracker.invalidAlias": "유효하지 않은 별칭",
    "tracker.enterValidAlias": "유효한 별칭을 입력해 주세요",

    // Charity Portal (GIV-254)
    "charity.portal.deleteTitle": "{{type}}을(를) 삭제하시겠습니까?",
    "charity.portal.deleteDescription":
      "이 작업은 되돌릴 수 없습니다. {{type}}이(가) 영구적으로 삭제됩니다.",
    "charity.portal.walletNotConfigured": "수신 지갑이 설정되지 않았습니다.",
    "charity.portal.walletDonationNote":
      "온체인 기부를 받으려면 지갑을 연결하세요.",
    "charity.portal.setupWallet": "지갑 설정",

    // Charity dashboard onboarding & verification
    "charity.onboarding.ariaLabel": "온보딩 체크리스트",
    "charity.onboarding.title": "시작하기",
    "charity.onboarding.progress": "{{total}}단계 중 {{completed}}단계 완료",
    "charity.onboarding.optional": "선택 사항",
    "charity.onboarding.allComplete":
      "모든 단계를 완료했습니다! 이 체크리스트를 닫아도 됩니다.",
    "charity.onboarding.expand": "체크리스트 펼치기",
    "charity.onboarding.collapse": "체크리스트 접기",
    "charity.onboarding.dismiss": "온보딩 체크리스트 닫기",
    "charity.onboarding.check": "{{label}} 체크",
    "charity.onboarding.uncheck": "{{label}} 체크 해제",
    "charity.onboarding.stepDone": "{{label}} (완료)",
    "charity.onboarding.stepAuto": "{{label}} (자동으로 완료됨)",
    "charity.onboarding.goToOrganization": "조직으로 이동",
    "charity.onboarding.setupWallet": "지갑 설정",
    "charity.onboarding.item.completeProfile.label": "조직 프로필 완성",
    "charity.onboarding.item.completeProfile.description":
      "조직 이름, 설명, 주소, 연락처 정보를 추가하세요.",
    "charity.onboarding.item.uploadLogo.label": "로고 또는 배너 이미지 업로드",
    "charity.onboarding.item.uploadLogo.description":
      "기부자가 자선단체를 쉽게 알아볼 수 있도록 로고나 배너를 추가하세요.",
    "charity.onboarding.item.connectWallet.label": "수령 지갑 설정",
    "charity.onboarding.item.connectWallet.description":
      "기부금을 받을 멀티시그 Safe, 기관 수탁 또는 단일 서명 지갑을 선택하세요. 메시지에 서명하여 통제권을 증명합니다.",
    "charity.onboarding.item.bankDetails.label":
      "법정화폐 출금용 은행 정보 설정",
    "charity.onboarding.item.bankDetails.description":
      "카드 기부를 받으려면 은행 정보를 설정하세요.",
    "charity.onboarding.item.acceptTerms.label": "서비스 약관 검토 및 동의",
    "charity.onboarding.item.acceptTerms.description":
      "Give Protocol 자선단체 이용 약관을 읽고 확인하세요.",
    "charity.verification.pendingTitle": "신청 검토 중",
    "charity.verification.pendingBody":
      "저희 팀이 자선단체 신청서를 검토하고 있습니다. 보통 영업일 기준 3~5일이 걸리며, 결정이 나면 이메일로 알려드리겠습니다.",
    "charity.verification.rejectedTitle": "신청이 승인되지 않았습니다",
    "charity.verification.reason": "사유: {{notes}}",
    "charity.verification.rejectedDefault":
      "이번에는 신청이 승인되지 않았습니다.",
    "charity.verification.contactSupport": "지원팀 문의",
    "charity.verification.suspendedTitle": "계정이 정지되었습니다",
    "charity.verification.suspendedDefault": "자선단체 계정이 정지되었습니다.",
    "charity.verification.appealSuspension": "정지 이의 신청",
    "charity.verification.verifiedTitle": "자선단체 인증 완료",
    "charity.verification.verifiedBody":
      "조직이 인증되었으며 이제 기부자가 귀하의 캠페인을 후원할 수 있습니다.",
    "charity.portal.receivingWallet": "수령 지갑: {{address}}",
    "charity.portal.loadError":
      "자선단체 데이터를 불러오지 못했습니다. 다시 시도해 주세요.",

    // Timestamps (GIV-254)
    "timestamp.justNow": "방금 전",
    "timestamp.oneMinuteAgo": "1분 전",
    "timestamp.minutesAgo": "{{count}}분 전",

    // Common additions (GIV-256)
    "common.previous": "이전",
    "common.next": "다음",
    "common.pageOfTotal": "{{total}}페이지 중 {{page}}페이지",
    "common.retry": "재시도",
    "common.processing": "처리 중...",
    "common.saving": "저장 중...",
    "common.donate": "기부하기",
    "common.active": "활성",

    // Portfolio Funds - public page (GIV-256)
    "portfolio.donationType": "기부 유형",
    "portfolio.devNative": "DEV (네이티브)",
    "portfolio.testToken": "TEST 토큰",
    "portfolio.donationAmount": "기부 금액:",
    "portfolio.platformFee": "플랫폼 수수료 ({{percentage}}%):",
    "portfolio.toCharities": "자선단체 배분:",
    "portfolio.eachCharityReceives": "각 자선단체 수령액:",
    "portfolio.donateToFund": "{{name}}에 기부하기",
    "portfolio.equalDistribution": "균등 배분",
    "portfolio.equalDistributionNote":
      "귀하의 기부금은 {{count}}개의 인증된 자선단체에 균등하게 배분됩니다.",
    "portfolio.eachCharityPercentage":
      "각 자선단체가 기부금의 {{percentage}}%를 받습니다",
    "portfolio.verifiedCharities": "인증된 자선단체 {{count}}개",
    "portfolio.donateToFundButton": "펀드에 기부하기",
    "portfolio.noFundsAvailable": "사용 가능한 포트폴리오 펀드가 없습니다",
    "portfolio.checkBackLater":
      "새로운 기부 기회가 마련되면 다시 확인해 주세요",
    "portfolio.amountLabel": "금액 ({{currency}})",
    "portfolio.invalidAmount": "유효한 금액을 입력해 주세요",
    "portfolio.donationSuccess": "기부가 성공적으로 완료되었습니다!",
    "portfolio.donationFailed": "기부에 실패했습니다. 다시 시도해 주세요.",

    // Admin - Activity event type labels (GIV-256)
    "admin.activity.donation": "기부",
    "admin.activity.registration": "등록",
    "admin.activity.verification": "검증",
    "admin.activity.volunteerHours": "봉사 시간",
    "admin.activity.default": "활동",

    // Admin - Dashboard page (GIV-256)
    "admin.dashboard.title": "관리자 대시보드",
    "admin.dashboard.alerts": "알림",
    "admin.dashboard.alertsPending": "{{count}}건 대기 중",
    "admin.dashboard.alertsView": "보기",
    "admin.dashboard.recentActivity": "최근 활동",
    "admin.dashboard.noRecentActivity": "최근 활동이 없습니다.",
    "admin.dashboard.quickActions": "빠른 작업",
    "admin.dashboard.errorTitle": "대시보드 로딩 오류",
    "admin.stats.last7d": "최근 7일",
    "admin.stats.last30d": "최근 30일",
    "admin.stats.totalDonors": "총 기부자",
    "admin.stats.newRegistrations": "신규 등록",
    "admin.stats.charities": "자선단체",
    "admin.stats.pendingVerification": "검증 대기 중",
    "admin.stats.verifiedCharities": "인증된 자선단체",
    "admin.stats.activeVolunteers": "활동 중인 봉사자",
    "admin.stats.totalDonationVolume": "총 기부 규모",
    "admin.stats.cryptoVolume": "암호화폐 규모",
    "admin.stats.fiatVolume": "법정화폐 규모",
    "admin.stats.donations": "건의 기부",

    // Admin - Quick Actions (GIV-256)
    "admin.actions.viewReports": "보고서 보기",
    "admin.actions.viewReportsDesc": "상세 분석 보고서 생성",
    "admin.actions.manageCharities": "자선단체 관리",
    "admin.actions.manageCharitiesDesc": "단체 검토 및 승인",
    "admin.actions.systemSettings": "시스템 설정",
    "admin.actions.systemSettingsDesc": "플랫폼 매개변수 설정",
    "admin.actions.manageImpactMetrics": "영향력 지표 관리",
    "admin.actions.manageImpactMetricsDesc": "영향력 계산기 데이터 설정",
    "admin.actions.donationMonitoring": "기부 모니터링",
    "admin.actions.donationMonitoringDesc": "기부 모니터링, 신고 및 보고",
    "admin.actions.contentModeration": "콘텐츠 관리",
    "admin.actions.contentModerationDesc":
      "기회 및 캠페인 숨기기, 신고 및 검토",
    "admin.actions.portfolioFunds": "포트폴리오 펀드",
    "admin.actions.portfolioFundsDesc":
      "큐레이션된 기부 포트폴리오 생성 및 관리",
    "admin.actions.charityRequests": "자선단체 요청",
    "admin.actions.charityRequestsDesc":
      "미등록 자선단체에 대한 기부자 요청 검토",

    // Admin - Portfolio Funds management page (GIV-256)
    "admin.portfolio.title": "포트폴리오 펀드",
    "admin.portfolio.subtitle": "큐레이션된 기부 포트폴리오 생성 및 관리",
    "admin.portfolio.newFund": "새 펀드",
    "admin.portfolio.editFund": "펀드 편집",
    "admin.portfolio.createNewFund": "새 펀드 만들기",
    "admin.portfolio.fundName": "펀드 이름",
    "admin.portfolio.fundNamePlaceholder": "예: 환경 영향 펀드",
    "admin.portfolio.description": "설명",
    "admin.portfolio.descriptionPlaceholder":
      "펀드의 목적과 영향력 초점을 설명해 주세요...",
    "admin.portfolio.category": "카테고리",
    "admin.portfolio.selectCategory": "카테고리 선택",
    "admin.portfolio.imageUrl": "이미지 URL",
    "admin.portfolio.imageUrlPlaceholder": "https://...",
    "admin.portfolio.selectCharities": "자선단체 선택 ({{count}}개 선택됨)",
    "admin.portfolio.noCharitiesFound": "인증된 자선단체를 찾을 수 없습니다",
    "admin.portfolio.saving": "저장 중...",
    "admin.portfolio.createFund": "펀드 만들기",
    "admin.portfolio.updateFund": "펀드 업데이트",
    "admin.portfolio.noFundsYet": "아직 포트폴리오 펀드가 없습니다",
    "admin.portfolio.noFundsMessage":
      "첫 번째 펀드를 만들어 자선단체를 묶음 기부용으로 그룹화하세요",
    "admin.portfolio.charity": "자선단체",
    "admin.portfolio.charities": "자선단체",
    "admin.portfolio.createdOn": "{{date}} 생성됨",
    "admin.portfolio.statusActive": "활성",
    "admin.portfolio.statusPaused": "일시 정지",
    "admin.portfolio.statusArchived": "보관됨",
    "admin.portfolio.errorLoad": "데이터를 불러오는 데 실패했습니다",
    "admin.portfolio.errorArchive": "펀드 보관에 실패했습니다",
    "admin.portfolio.fundArchived": "펀드가 보관되었습니다",
    "admin.portfolio.fundUpdated": "펀드가 업데이트되었습니다",
    "admin.portfolio.fundCreated": "펀드가 생성되었습니다",
    "admin.portfolio.errorSave": "펀드 저장에 실패했습니다",

    // Admin - Charity Management page (GIV-256)
    "admin.charity.title": "자선단체 관리",
    "admin.charity.totalCount": "총 {{count}}개",
    "admin.charity.allStatuses": "모든 상태",
    "admin.charity.searchPlaceholder": "이름으로 검색\u2026",
    "admin.charity.colName": "이름",
    "admin.charity.colEin": "납세자 번호",
    "admin.charity.taxIdDisplay": "납세자 번호 {{value}}",
    "admin.charity.searchByNameEin": "이름 또는 납세자 번호로 검색…",
    "admin.charity.colCategory": "카테고리",
    "admin.charity.colStatus": "상태",
    "admin.charity.colSigner": "연락처",
    "admin.charity.colJoined": "가입일",
    "admin.charity.colWallet": "지갑",
    "admin.charity.colActions": "작업",
    "admin.charity.walletNotSet": "미설정",
    "admin.charity.approve": "승인",
    "admin.charity.reject": "거부",
    "admin.charity.suspend": "정지",
    "admin.charity.reinstate": "복원",
    "admin.charity.statusPending": "대기 중",
    "admin.charity.statusVerified": "인증됨",
    "admin.charity.statusApproved": "승인됨",
    "admin.charity.statusRejected": "거부됨",
    "admin.charity.statusSuspended": "정지됨",
    "admin.charity.approveTitle": "자선단체 승인",
    "admin.charity.rejectTitle": "자선단체 거부",
    "admin.charity.suspendTitle": "자선단체 정지",
    "admin.charity.reinstateTitle": "자선단체 복원",
    "admin.charity.confirmAction": "작업 확인",
    "admin.charity.reasonRequired": "사유 (필수)",
    "admin.charity.reasonOptional": "사유 (선택 사항)",
    "admin.charity.saving": "저장 중\u2026",
    "admin.charity.confirm": "확인",
    "admin.charity.noResults": "필터 조건에 맞는 자선단체를 찾을 수 없습니다.",
    "admin.charity.unnamed": "이름 없는 단체",

    // Admin - Charity Requests page (GIV-256)
    "admin.charityRequests.title": "자선단체 요청",
    "admin.charityRequests.subtitle":
      "기부자가 제출한 미등록 자선단체 요청으로 조직별로 그룹화되어 있습니다. 관심도가 높은 단체를 우선적으로 연락해야 합니다.",
    "admin.charityRequests.ein": "납세자 번호",
    "admin.charityRequests.requests": "요청",
    "admin.charityRequests.latestRequester": "최근 요청자",
    "admin.charityRequests.latestRequest": "최근 요청",
    "admin.charityRequests.firstRequest": "최초 요청",
    "admin.charityRequests.empty": "아직 자선단체 요청이 제출되지 않았습니다.",
    "admin.charityRequests.errorTitle": "자선단체 요청 로딩 오류",
    "admin.charityRequests.showing":
      "총 {{total}}개 고유 조직 중 {{shown}}개 표시 중.",

    // Admin - Volunteer Validation page (GIV-256)
    "admin.validation.title": "봉사 검증 감독",
    "admin.validation.totalCount": "총 {{count}}건의 요청",
    "admin.validation.pipelineStats": "파이프라인 통계",
    "admin.validation.noStats": "통계를 사용할 수 없습니다.",
    "admin.validation.pending": "대기 중",
    "admin.validation.approved": "승인됨",
    "admin.validation.rejected": "거부됨",
    "admin.validation.expired": "만료됨",
    "admin.validation.avgResponseTime": "평균 응답 시간:",
    "admin.validation.expirationRate": "만료율:",
    "admin.validation.rejectionRate": "거부율:",
    "admin.validation.searchPlaceholder": "봉사자, 단체 검색\u2026",
    "admin.validation.requestsTab": "검증 요청",
    "admin.validation.patternsTab": "의심스러운 패턴",
    "admin.validation.colVolunteer": "봉사자",
    "admin.validation.colOrganisation": "단체",
    "admin.validation.colHours": "시간",
    "admin.validation.colActivityDate": "활동 날짜",
    "admin.validation.colHrsPerWeek": "주당 시간",
    "admin.validation.colTotalRequests": "총 요청",
    "admin.validation.override": "재정의",
    "admin.validation.noPatterns": "의심스러운 패턴이 감지되지 않았습니다.",
    "admin.validation.noRequests": "검증 요청을 찾을 수 없습니다.",
    "admin.validation.patternsDescription":
      "7일 롤링 기간 동안 설정된 임계값 이상의 시간을 보고한 봉사자가 표시됩니다. 이러한 패턴은 자체 보고 시간 시스템의 남용을 나타낼 수 있습니다.",
    "admin.validation.overrideTitle": "검증 요청 재정의",
    "admin.validation.newStatus": "새 상태",
    "admin.validation.reasonRequired": "사유 (필수)",
    "admin.validation.reasonPlaceholder":
      "이 요청을 재정의하는 사유를 설명해 주세요\u2026",
    "admin.validation.saving": "저장 중\u2026",
    "admin.validation.confirmOverride": "재정의 확인",
    "admin.validation.allStatuses": "모든 상태",
    "admin.validation.colStatus": "상태",
    "admin.validation.colCreated": "생성일",

    // GIV-266: Delta translations (354 keys)
    "home.hero.title": "투명한 나눔",
    "home.hero.titleAccent": "지속 가능한 임팩트",
    "home.hero.description":
      "디지털 시대를 위한 혁신적으로 투명한 자선 활동. 임팩트를 위해 설계되고, 검증 가능한 기술로 뒷받침됩니다. 모든 기부금이 기부자에서 수혜자까지 추적 가능합니다.",
    "home.hero.visionTitle": "우리의 비전",
    "home.hero.visionText":
      "Give Protocol은 고신뢰 나눔의 미래를 설계하고 있습니다. 우리는 첨단 기술 인프라를 활용하여 글로벌 자본과 지역 임팩트 사이의 격차를 해소합니다. 원활한 디지털 자산 지원과 전통적인 기부 방식을 통합함으로써, 일회성 기부를 세계에서 가장 중요한 대의를 위한 영구적인 지원 엔진으로 전환하는 회복력 있는 자금 생태계를 구축하고 있습니다.",
    "home.comingSoon": "출시 예정",
    "home.readDocs": "문서 읽기",
    "home.features.sectionTitle": "투명한 자선 활동의 관문",
    "home.features.sectionSubtitle":
      "암호화폐 또는 법정화폐로 원활하게 기부할 수 있는 멀티체인 인프라 — 완전한 투명성 보장",
    "home.features.highEfficiency.title": "고효율 기부",
    "home.features.highEfficiency.description":
      "검증된 단체에 모호함 없이 직접 기부하세요. 자동화된 원장이 실시간 검증을 제공하여 귀하의 지원이 가장 필요한 곳에 정확히 전달되도록 보장합니다.",
    "home.features.equityFunds.title": "자선 지분 펀드",
    "home.features.equityFunds.description":
      "일회성 기부를 넘어 스마트 관리 지분 펀드에 기여하세요. 정교하고 저위험 디지털 전략을 활용하여 귀하의 원금을 지속적인 자금 흐름으로 전환하며, 자선 사업을 대대로 지원합니다.",
    "home.features.impactFunds.title": "임팩트 펀드",
    "home.features.impactFunds.description":
      "특정 대의를 위해 자원을 모으세요. 환경, 교육, 빈곤 구제 — 집단적 행동을 통해 귀하의 기부가 증폭됩니다.",
    "home.features.verifiedOrgs.title": "인증된 단체",
    "home.features.verifiedOrgs.description":
      "등록된 모든 단체를 검색하거나 인증 배지를 확인하세요. 당사의 심사 절차에 참여하는 단체는 기부자가 신뢰할 수 있는 온체인 인증을 획득합니다.",
    "home.features.blockchainVerified.title": "블록체인 인증",
    "home.features.blockchainVerified.description":
      "소울바운드 토큰이 봉사 기여를 인정합니다. 기술, 시간, 임팩트 — 모두 온체인에 영구적으로 기록됩니다.",
    "home.features.bridgingModes.title": "기부 방식의 연결",
    "home.features.bridgingModes.description":
      "USD든 디지털 자산이든, 멀티 네트워크 아키텍처가 귀하의 기부를 현대 세계의 속도로 전달합니다.",
    "home.roles.title": "세상을 변화시키는 모든 분을 위해",
    "home.roles.donors.title": "기부자를 위해",
    "home.roles.donors.item1": "암호화폐 또는 법정화폐로 기부 — 자유롭게 선택",
    "home.roles.donors.item2": "거버넌스 참여",
    "home.roles.donors.item3": "온체인 평판 구축",
    "home.roles.nonprofits.title": "비영리단체를 위해",
    "home.roles.nonprofits.item1": "새로운 기부자층 확보",
    "home.roles.nonprofits.item2": "CEF를 통한 지속 가능한 자금 조달",
    "home.roles.nonprofits.item3": "강화된 투명성 보고",
    "home.roles.volunteers.title": "봉사자를 위해",
    "home.roles.volunteers.item1": "검증 가능한 기여 기록",
    "home.roles.volunteers.item2": "이동 가능한 기술 자격 증명 (SBT)",
    "home.roles.volunteers.item3": "성취 배지 및 인정",
    "home.impact.title": "계획된 임팩트 펀드",
    "home.impact.environmental.title": "환경 임팩트 펀드",
    "home.impact.environmental.description":
      "산림 복원, 해양 정화, 재생 에너지 이니셔티브를 지원합니다. 모금된 기부금은 측정 가능한 임팩트를 만드는 인증된 환경 단체에 전달됩니다.",
    "home.impact.education.title": "교육 기회 펀드",
    "home.impact.education.description":
      "장학금, 디지털 학습 도구, 교사 연수를 제공합니다. 소외된 지역사회의 교육 이니셔티브를 지원하기 위해 집단 기금이 증폭됩니다.",
    "home.cta.title": "기부를 혁신할 준비가 되셨나요?",
    "home.cta.subtitle":
      "투명하고 블록체인 기반의 자선 활동을 먼저 경험하세요. 더 나은 자선 기부의 미래를 함께 만들어 나갈 커뮤니티에 참여하세요.",
    "home.cta.explore": "대의 탐색하기",
    "home.nav.features": "기능",
    "home.nav.impact": "임팩트",
    "home.nav.charities": "자선단체",
    "home.nav.volunteer": "봉사",
    "home.footer.brand.tagline":
      "블록체인 투명성과 지속 가능한 자금 조달로 자선 활동을 혁신합니다.",
    "home.footer.product.title": "서비스",
    "home.footer.product.impactFunds": "임팩트 펀드",
    "home.footer.product.charities": "자선단체를 위해",
    "home.footer.product.volunteers": "봉사자를 위해",
    "home.footer.resources.title": "자료",
    "home.footer.resources.whitepaper": "백서 (출시 예정)",
    "home.footer.resources.blog": "블로그 (출시 예정)",
    "home.footer.resources.community": "커뮤니티 (출시 예정)",
    "home.footer.connect.title": "연결",
    "home.footer.connect.contact": "문의 (출시 예정)",
    "home.footer.copyright":
      "Give Protocol. 멀티체인 설계. Give Protocol 봉사자들이 운영합니다.",
    "auth.signin.welcomeBack": "다시 오신 것을 환영합니다",
    "auth.signin.subtitle": "Give Protocol 계정에 로그인하세요",
    "auth.signin.emailPlaceholder": "이메일",
    "auth.signin.passwordPlaceholder": "비밀번호",
    "auth.signin.submitting": "로그인 중…",
    "auth.signin.withPasskey": "패스키로 로그인",
    "auth.signin.withGoogle": "Google로 계속하기",
    "auth.signin.or": "또는",
    "auth.signin.newToProtocol": "Give Protocol이 처음이신가요?",
    "auth.signin.createAccount": "계정 만들기 →",
    "auth.signin.forgotPasswordLink": "비밀번호를 잊으셨나요? →",
    "auth.signin.sslEncrypted": "TLS 암호화",
    "auth.signin.modeToggleLabel": "로그인 방법",
    "auth.signin.terms": "이용약관",
    "auth.signin.privacy": "개인정보 보호",
    "auth.panel.headline": "스마트한 기부, 투명한 임팩트.",
    "auth.panel.subheadline":
      "하나의 계정. 카드 또는 암호화폐로 기부. 모든 금액을 온체인에서 추적.",
    "auth.panel.statusLabel": "프로토콜 상태 · 제네시스 단계",
    "auth.panel.statusDesc": "투명한 기부의 기반을 구축하고 있습니다",
    "auth.panel.runsOn": "기반 기술",
    "auth.wallet.connect": "지갑 연결",
    "auth.wallet.connecting": "지갑 연결 중…",
    "auth.wallet.signing": "메시지 서명 중…",
    "auth.wallet.verifying": "검증 중…",
    "auth.wallet.openingSession": "세션 열기 중…",
    "auth.validation.emailRequired": "먼저 이메일 주소를 입력해 주세요",
    "auth.validation.invalidEmail": "유효한 이메일 주소를 입력해 주세요",
    "auth.validation.passwordTooShort": "비밀번호는 8자 이상이어야 합니다",
    "auth.validation.passwordMismatch": "비밀번호가 일치하지 않습니다",
    "auth.login.welcomeHeading": "Give Protocol에 오신 것을 환영합니다",
    "auth.login.signInOrConnect": "로그인 또는 연결",
    "auth.login.skipToContent": "로그인 콘텐츠로 건너뛰기",
    "auth.login.donorTitle": "기부자 로그인",
    "auth.login.donorSubtitle": "기부 대시보드에 접속하려면 로그인하세요",
    "auth.login.charityTitle": "비영리단체 포털",
    "auth.login.charitySubtitle": "단체 프로필과 기부금을 관리하세요",
    "auth.login.back": "← 뒤로",
    "auth.login.continueDonor": "기부자로 계속",
    "auth.login.connecting": "연결 중…",
    "auth.login.connectWalletSignIn": "지갑 연결 및 로그인",
    "auth.login.newToPlatform": "Give Protocol이 처음이신가요?",
    "auth.login.newDonorSignUp": "새 기부자 가입",
    "auth.login.manageNonprofit": "비영리단체를 관리하고 있습니다",
    "auth.login.nonprofitTrayTitle": "Give Protocol이 처음이신가요?",
    "auth.login.createNonprofitAccount": "비영리단체 계정 만들기",
    "auth.login.registerOrg": "Give Protocol에 단체를 등록하세요",
    "auth.login.needHelp": "도움이 필요하신가요?",
    "auth.login.forgotUsernameBtn": "사용자 이름을 잊으셨나요?",
    "auth.login.forgotPasswordBtn": "비밀번호를 잊으셨나요?",
    "auth.donorLogin.mismatch":
      "기부자 계정을 찾을 수 없습니다. 이 이메일은 자선단체 계정으로 등록되어 있습니다. 자선단체 로그인을 이용해 주세요.",
    "auth.donorLogin.signingIn": "로그인 중…",
    "auth.donorLogin.redirecting": "{{count}}초 후 이동합니다...",
    "auth.donorReg.pleaseWait": "잠시만 기다려 주세요…",
    "auth.donorReg.signUpPasskey": "패스키로 가입",
    "auth.donorReg.withGoogle": "Google로 계속하기",
    "auth.donorReg.connectWallet": "지갑 연결",
    "auth.donorReg.orSetPassword": "또는 비밀번호 설정",
    "auth.donorReg.creating": "계정 생성 중...",
    "auth.donorReg.createAccount": "기부자 계정 만들기",
    "auth.donorReg.privacyNotice": "계정을 생성하면 다음에 동의하게 됩니다:",
    "auth.donorReg.termsLink": "이용약관",
    "auth.donorReg.privacyAnd": "및",
    "auth.donorReg.privacyLink": "개인정보 처리방침",
    "auth.charityLogin.mismatch":
      "이 이메일은 기부자 계정으로 등록되어 있습니다. 기부자 포털에서 로그인해 주세요.",
    "auth.charityLogin.signingIn": "로그인 중...",
    "auth.charityLogin.or": "또는",
    "auth.charityLogin.connecting": "연결 중...",
    "auth.charityLogin.connectWallet": "지갑 연결",
    "auth.forgot.resetPassword": "비밀번호 재설정",
    "auth.forgot.forgotUsername": "사용자 이름 찾기",
    "auth.forgot.passwordDesc":
      "이메일 주소를 입력하시면 비밀번호 재설정 링크를 보내드리겠습니다.",
    "auth.forgot.usernameDesc":
      "이메일 주소를 입력하시면 사용자 이름을 보내드리겠습니다.",
    "auth.forgot.passwordSuccess":
      "비밀번호 재설정 안내가 이메일로 발송되었습니다",
    "auth.forgot.usernameSuccess": "사용자 이름 알림이 이메일로 발송되었습니다",
    "auth.forgot.checkEmail": "이메일을 확인해 주세요",
    "auth.forgot.backToSignIn": "로그인으로 돌아가기",
    "auth.forgot.emailPlaceholder": "이메일 주소를 입력하세요",
    "auth.forgot.genericError": "오류가 발생했습니다. 다시 시도해 주세요.",
    "auth.forgot.sending": "발송 중...",
    "auth.forgot.sendResetLink": "재설정 링크 보내기",
    "auth.forgot.sendUsername": "사용자 이름 보내기",

    // Reset password (set new password page) — pending translation (GIV-367)
    "auth.resetPassword.title": "Set New Password",
    "auth.resetPassword.subtitle": "Choose a strong password for your account.",
    "auth.resetPassword.newPassword": "New Password",
    "auth.resetPassword.confirmPassword": "Confirm New Password",
    "auth.resetPassword.submit": "Update Password",
    "auth.resetPassword.updating": "Updating\u2026",
    "auth.resetPassword.mismatch": "Passwords do not match.",
    "auth.resetPassword.success": "Password updated successfully!",
    "auth.resetPassword.successSubtitle":
      "You can now sign in with your new password.",
    "auth.resetPassword.backToSignIn": "Back to Sign In",
    "auth.resetPassword.invalidLink":
      "This password reset link is invalid or has expired.",
    "auth.resetPassword.requestNew": "Request a new reset link",
    "auth.resetPassword.validating": "Validating reset link\u2026",
    "auth.orgSearch.orgNameLabel": "단체명",
    "auth.orgSearch.searchPlaceholder": "단체명으로 검색...",
    "auth.orgSearch.countryLabel": "국가",
    "auth.orgSearch.allCountries": "모든 국가",
    "auth.orgSearch.searchPrompt":
      "데이터베이스에서 귀하의 단체를 찾아 인수하세요.",
    "auth.orgSearch.noResults": "단체를 찾을 수 없습니다.",
    "auth.orgSearch.loadMore": "더 보기",
    "auth.orgSearch.cantFind": "단체를 찾을 수 없나요?",
    "auth.orgSearch.registerManually": "직접 등록하기",
    "charity.claim.orgDetails": "단체 정보 (등록 기관 제공)",
    "charity.claim.orgNameLabel": "이름",
    "charity.claim.einLabel": "납세자 번호",
    "charity.claim.locationLabel": "위치",
    "charity.claim.contactInfo": "연락처 정보",
    "charity.claim.contactName": "담당자 이름",
    "charity.claim.contactEmail": "연락처 이메일",
    "charity.claim.accountSecurity": "계정 보안",
    "charity.claim.password": "비밀번호",
    "charity.claim.confirmPassword": "비밀번호 확인",
    "charity.claim.backToSearch": "검색으로 돌아가기",
    "charity.claim.creating": "계정 생성 중...",
    "charity.claim.submit": "단체 인수",
    "charity.claim.validation.name": "이름은 2자에서 100자 사이여야 합니다",
    "charity.claim.validation.email": "유효한 이메일 주소를 입력해 주세요",
    "charity.claim.validation.password": "비밀번호는 8자 이상이어야 합니다",
    "charity.claim.validation.confirmPassword": "비밀번호가 일치하지 않습니다",
    "charity.claim.validation.fix": "유효성 검사 오류를 수정해 주세요",
    "charity.claim.useAsPublicEmail":
      "내 이메일을 단체의 공개 연락처 이메일로 사용",
    "charity.claim.publicContactEmail": "단체 공개 연락처 이메일",
    "charity.claim.privacyNotice":
      "개인 서명자 이메일/전화번호는 인증 목적으로만 사용되며 다른 플랫폼 사용자에게 표시되지 않습니다. 공개 연락처 이메일은 단체 프로필에 표시됩니다.",
    "charity.claim.secondContactTitle": "보조 연락처",
    "charity.claim.secondContactName": "보조 연락처 이름",
    "charity.claim.secondContactEmail": "보조 연락처 이메일",
    "charity.claim.secondContactHint":
      "자선 단체의 지갑 또는 정산 정보가 변경될 때 알림을 받을 다른 담당자입니다.",
    "charity.claim.validation.secondEmailDistinct":
      "보조 연락처 이메일은 기본 이메일과 달라야 합니다",
    "charity.claim.error.creation": "계정 생성에 실패했습니다",
    "charity.claim.error.generic": "계정을 만들 수 없습니다",
    "charity.vetting.orgDetails": "단체 정보",
    "charity.vetting.orgName": "단체명",
    "charity.vetting.description": "설명",
    "charity.vetting.taxId": "납세자 번호 또는 등록 번호",
    "charity.vetting.countryLabel": "국가",
    "charity.vetting.selectCountry": "국가 선택",
    "charity.vetting.address": "주소",
    "charity.vetting.streetAddress": "도로명 주소",
    "charity.vetting.city": "도시",
    "charity.vetting.state": "시/도",
    "charity.vetting.postalCode": "우편번호",
    "charity.vetting.contactInfo": "연락처 정보",
    "charity.vetting.contactName": "담당자 이름",
    "charity.vetting.contactEmail": "연락처 이메일",
    "charity.vetting.accountSecurity": "계정 보안",
    "charity.vetting.password": "비밀번호",
    "charity.vetting.confirmPassword": "비밀번호 확인",
    "charity.vetting.submitting": "신청서 제출 중...",
    "charity.vetting.submit": "자선단체 신청서 제출",
    "charity.vetting.validation.orgName":
      "단체명은 2자에서 100자 사이여야 합니다",
    "charity.vetting.validation.contactName":
      "담당자 이름은 2자에서 100자 사이여야 합니다",
    "charity.vetting.validation.email": "유효한 이메일 주소를 입력해 주세요",
    "charity.vetting.validation.password": "비밀번호는 8자 이상이어야 합니다",
    "charity.vetting.validation.confirmPassword":
      "비밀번호가 일치하지 않습니다",
    "charity.vetting.validation.description": "설명은 필수입니다",
    "charity.vetting.validation.category": "카테고리는 필수입니다",
    "charity.vetting.validation.taxId": "납세자 번호는 필수입니다",
    "charity.vetting.validation.streetAddress": "도로명 주소는 필수입니다",
    "charity.vetting.validation.city": "도시는 필수입니다",
    "charity.vetting.validation.country": "국가는 필수입니다",
    "charity.vetting.validation.fix": "유효성 검사 오류를 수정해 주세요",
    "charity.vetting.error.generic": "신청서 제출에 실패했습니다",
    "charity.vetting.privacyNotice":
      "이 신청서를 제출하면 다음에 동의하게 됩니다:",
    "charity.vetting.termsLink": "이용약관",
    "charity.vetting.privacyAnd": "및",
    "charity.vetting.privacyLink": "개인정보 처리방침",
    "common.email": "이메일",
    "common.password": "비밀번호",
    "common.confirmPassword": "비밀번호 확인",
    "footer.brand.tagline": "지속 가능한 자선 기부의 장벽을 허물고 있습니다.",
    "footer.resources.title": "자료",
    "footer.resources.faq": "자주 묻는 질문",
    "footer.resources.about": "소개",
    "footer.legal.title": "법적 정보",
    "footer.legal.terms": "이용약관",
    "footer.legal.privacy": "개인정보처리방침",
    "footer.legal.cookiePreferences": "쿠키 환경설정",
    "consent.banner.ariaLabel": "쿠키 동의",
    "consent.banner.body":
      "앱 사용 방식을 이해하고 오류를 감지하기 위해 Google Analytics 4(Google LLC, 미국) 및 Sentry(Functional Software, 미국/EU)를 사용합니다. 이메일 주소, 지갑 주소 또는 기부자 이름은 공유되지 않습니다. 언제든지 동의를 철회할 수 있습니다.",
    "consent.banner.privacyLink": "개인정보처리방침",
    "consent.banner.acceptAll": "모두 수락",
    "consent.banner.decline": "비필수 항목 거부",
    "consent.banner.customize": "맞춤 설정",
    "consent.modal.title": "쿠키 환경설정",
    "consent.modal.essentialTitle": "필수",
    "consent.modal.essentialDesc":
      "탐색 및 인증과 같은 핵심 사이트 기능에 필요합니다. 비활성화할 수 없습니다.",
    "consent.modal.essentialAlwaysOn": "필수 쿠키 — 항상 활성",
    "consent.modal.analyticsTitle":
      "분석(Google Analytics 4 · 미국, Sentry · 미국/EU)",
    "consent.modal.analyticsDesc":
      "분석 쿠키는 어떤 페이지가 방문되고 사용자가 앱에서 어떻게 탐색하는지 이해하는 데 도움을 줍니다. Google Analytics 4를 사용합니다 \u2014 세션 식별자, 페이지 URL, 기기/브라우저 메타데이터, 익명화된 IP의 대략적인 위치(Google LLC, 미국; SCCs + EU\u2013US Data Privacy Framework). Sentry \u2014 안정성 모니터링을 위한 익명화된 오류 추적 및 브라우저 메타데이터(Functional Software, EU/미국; 전송 메커니즘 보류 중). 이메일 주소, 지갑 주소 또는 기부자 이름은 어떤 처리자와도 공유되지 않습니다.",
    "consent.modal.analyticsOn": "분석 및 오류 기록 — 켜짐",
    "consent.modal.analyticsOff": "분석 및 오류 기록 — 꺼짐",
    "consent.modal.cancel": "취소",
    "consent.modal.save": "환경설정 저장",
    "footer.connect.title": "연결",
    "footer.copyright": "Give Protocol. 모든 권리 보유.",
    "nav.signIn": "로그인",
    "nav.signOut": "로그아웃",
    "nav.privacy": "개인정보 보호",
    "auth.signup.heading": "계정 만들기",
    "auth.signup.subtitle": "투명한 기부 운동에 참여하세요",
    "auth.signup.displayName": "표시 이름",
    "auth.signup.emailPlaceholder": "이메일",
    "auth.signup.passwordPlaceholder": "비밀번호",
    "auth.signup.confirmPasswordPlaceholder": "비밀번호 확인",
    "auth.signup.submit": "계정 만들기",
    "auth.signup.submitting": "계정 생성 중…",
    "auth.signup.withPasskey": "패스키로 가입",
    "auth.signup.withGoogle": "Google로 계속하기",
    "auth.signup.connectWallet": "지갑 연결",
    "auth.signup.orSetPassword": "또는 비밀번호 설정",
    "auth.signup.alreadyHaveAccount": "이미 계정이 있으신가요?",
    "auth.signup.signInLink": "로그인",
    "auth.signup.manageNonprofit": "비영리단체를 관리하시나요?",
    "auth.signup.trustText": "귀하의 데이터는 다음에 의해 보호됩니다",
    "auth.signup.and": "및",
    "auth.signup.privacyPolicy": "개인정보처리방침",
    "auth.signup.panel.headline": "검증 가능한 기부.",
    "browse.hero.title": "온체인으로 검증된 기부.",
    "browse.hero.subtitle":
      "검증된 기부처를 발견하고 카드나 디지털 자산으로 기부하며 내 시간과 자원이 만드는 실질적인 변화를 확인하세요.",
    "browse.stats.networks": "지원 네트워크",
    "browse.stats.sectors": "자선 분야",
    "browse.stats.verifiedOrgs": "인증된 단체",
    "browse.stats.volunteerHours": "봉사 시간",
    "browse.verified": "인증됨",
    "browse.donate": "기부하기",
    "browse.viewProfile": "프로필 보기",
    "browse.filter.ariaLabel": "자선단체 필터",
    "browse.filter.searchAria": "자선단체 검색",
    "browse.filter.locationAria": "위치 검색",
    "browse.results.ariaLabel": "자선단체 검색 결과",
    "browse.tabs.charities": "자선단체",
    "browse.tabs.causes": "대의",
    "browse.tabs.funds": "포트폴리오 펀드",
    "browse.tabs.ariaLabel": "카테고리 탐색",
    "browse.featured.heading": "주요 단체",
    "browse.featured.ariaLabel": "주요 단체",
    "browse.featured.nextAria": "다음 주요 단체",
    "browse.causes.heading": "주요 대의",
    "browse.causes.ariaLabel": "주요 대의",
    "browse.causes.badge": "대의",
    "browse.causes.raised": "모금됨",
    "browse.causes.percentOf": "% 중",
    "browse.causes.by": "주최",
    "browse.causes.supportCta": "이 대의 후원하기",
    "browse.causes.giveCta": "기부하기",
    "browse.causes.nextAria": "다음 주요 대의",
    "browse.funds.heading": "포트폴리오 펀드",
    "browse.funds.ariaLabel": "포트폴리오 펀드",
    "browse.funds.badge": "포트폴리오 펀드",
    "browse.funds.charity": "자선단체",
    "browse.funds.charities": "자선단체",
    "browse.funds.donateCta": "펀드에 기부하기",
    "browse.funds.nextAria": "다음 포트폴리오 펀드",
    "portfolio.notFound.title": "포트폴리오 펀드를 찾을 수 없습니다",
    "portfolio.notFound.body":
      "찾으시는 포트폴리오 펀드가 존재하지 않거나 더 이상 활성 상태가 아닙니다.",
    "portfolio.supportedOrgs": "지원 단체",
    "browse.charity.einLabel": "납세자 번호",
    "browse.charity.einDisplay": "납세자 번호: {{value}}",
    "browse.charity.nteeLabel": "부문 코드",
    "browse.charity.deductibilityLabel": "세금 공제 가능 여부",
    "browse.charity.onPlatform": "플랫폼 등록",
    "browse.charity.loading": "로딩 중…",
    "browse.charity.loadMore": "더 보기",
    "browse.filter.searchPlaceholder": "자선단체 검색...",
    "browse.filter.locationPlaceholder": "도시, 주 또는 국가...",
    "browse.whyGiveProtocol.heading": "왜 Give Protocol인가요?",
    "browse.whyGiveProtocol.verified.title": "인증된 비영리 단체",
    "browse.whyGiveProtocol.verified.description":
      "모든 단체는 플랫폼에 표시되기 전에 공공 등록부와 대조하여 검증됩니다.",
    "browse.whyGiveProtocol.onchain.title": "온체인 투명성",
    "browse.whyGiveProtocol.onchain.description":
      "기부금은 블록체인에 기록되어 지갑에서 목적까지 영향을 추적할 수 있습니다.",
    "browse.whyGiveProtocol.volunteer.title": "돈뿐만 아니라 시간도 기부하세요",
    "browse.whyGiveProtocol.volunteer.description":
      "봉사 시간은 자선단체가 검증하며 프로토콜 평판에 반영됩니다.",
    "browse.news.heading": "플랫폼 소식",
    "admin.news.deleteConfirmBody": "“{{title}}”이(가) 영구적으로 삭제됩니다. 이 작업은 되돌릴 수 없습니다.",
    "admin.news.deleteConfirmTitle": "소식을 삭제하시겠습니까?",
    "admin.news.saveFailed": "변경 사항을 저장하지 못했습니다. 다시 시도해 주세요.",
    "admin.news.urlHelp": "선택 사항입니다. 비워 두면 링크 없이 표시됩니다.",
    "admin.news.urlInvalid": "전체 https:// 주소 또는 /로 시작하는 경로를 입력하세요.",
    "browse.carousel.error": "이 섹션을 불러오지 못했습니다. 페이지를 새로 고친 후 다시 시도해 주세요.",
    "browse.carousel.goToPage": "{{page}}페이지로 이동",
    "browse.carousel.pageLabel": "{{current}} / {{total}} 페이지",
    "browse.carousel.pause": "자동 전환 일시정지",
    "browse.carousel.play": "자동 전환 재개",
    "browse.causes.empty": "아직 등록된 대의가 없습니다. 곧 다시 확인해 주세요!",
    "browse.causes.prevAria": "이전 추천 대의",
    "browse.causes.searchPlaceholder": "대의 검색...",
    "browse.causes.subheading": "실질적인 변화를 만드는 구체적인 프로젝트를 후원하세요.",
    "browse.charity.registryIdDisplay": "등록 ID: {{value}}",
    "browse.featured.empty": "아직 추천 단체가 없습니다. 위의 검색으로 자선단체를 찾아보세요.",
    "browse.featured.prevAria": "이전 추천 단체",
    "browse.featured.subheading": "Give Protocol에서 검증된 자선단체를 차례로 소개합니다.",
    "browse.filter.addLocation": "위치 추가",
    "browse.filter.impactNotice": "영향 지역 필터는 아직 제공되지 않아 결과가 영향 지역으로 좁혀지지 않습니다.",
    "browse.filter.locationHint": "Enter 키를 누르거나 추가를 선택해 위치를 적용하세요.",
    "browse.filter.minChars": "검색하려면 2자 이상 입력하세요.",
    "browse.funds.empty": "아직 포트폴리오 펀드가 없습니다. 곧 다시 확인해 주세요!",
    "browse.funds.prevAria": "이전 포트폴리오 펀드",
    "browse.funds.searchPlaceholder": "포트폴리오 펀드 검색...",
    "browse.funds.subheading": "검증된 자선단체에 기부금을 배분하는 엄선된 기부 포트폴리오입니다.",
    "browse.registry.badge": "{{registry}} 등록",
    "browse.results.empty": "검색 조건에 맞는 단체가 없습니다. 다른 키워드를 사용하거나 위치 필터를 추가해 보세요.",
    "browse.results.error": "검색을 실행하지 못했습니다. 다시 시도해 주세요.",
    "browse.search.noMatches": "“{{query}}”와(과) 일치하는 항목이 없습니다.",
    "browse.category.A": "예술 및 문화",
    "browse.category.B": "교육",
    "browse.category.C": "환경",
    "browse.category.D": "동물 복지",
    "browse.category.E": "건강",
    "browse.category.F": "정신 건강",
    "browse.category.G": "의학 연구",
    "browse.category.H": "생물의학 연구",
    "browse.category.I": "범죄 및 법률",
    "browse.category.J": "고용",
    "browse.category.K": "식품 및 영양",
    "browse.category.L": "주거",
    "browse.category.M": "공공 안전",
    "browse.category.N": "여가",
    "browse.category.O": "청소년 발달",
    "browse.category.P": "휴먼 서비스",
    "browse.category.Q": "국제",
    "browse.category.R": "시민권",
    "browse.category.S": "지역사회 개발",
    "browse.category.T": "자선 활동",
    "browse.category.U": "과학 및 기술",
    "browse.category.V": "사회과학",
    "browse.category.W": "공공 정책",
    "browse.category.X": "종교",
    "browse.category.Y": "상호 이익",
    "browse.category.default": "비영리 단체",
    "cause.causes": "대의",
    "cause.createNew": "새로 만들기",
    "cause.noCausesTitle": "아직 대의가 없습니다",
    "cause.name": "이름",
    "cause.description": "설명",
    "cause.category": "카테고리",
    "cause.targetAmount": "목표 금액",
    "cause.headerImage": "헤더 이미지",
    "cause.impact": "임팩트",
    "cause.impactHelp": "이 대의의 기대 효과를 설명해 주세요.",
    "cause.location": "위치",
    "cause.timeline": "일정",
    "cause.partners": "파트너",
    "cause.limitReached": "대의 생성 한도 도달",
    "impact.statistics": "임팩트 통계",
    "impact.statLabel": "라벨",
    "impact.statValue": "값",
    "impact.missionStatement": "사명 선언문",
    "impact.missionPlaceholder": "우리의 사명은...",
    "impact.highlights": "임팩트 하이라이트",
    "impact.highlight": "임팩트 하이라이트",
    "impact.addHighlight": "하이라이트 추가",
    "impact.profile": "임팩트 프로필",
    "impact.loadError": "임팩트 프로필을 불러오지 못했습니다",
    "impact.saveError": "임팩트 프로필 저장에 실패했습니다",
    "impact.saveSuccess": "임팩트 프로필이 저장되었습니다",
    "organization.yearFounded": "설립 연도",
    "organization.address": "주소",
    "organization.street": "도로명 주소",
    "organization.city": "도시",
    "organization.stateProvince": "시/도",
    "organization.postalCode": "우편번호",
    "organization.country": "국가",
    "organization.contactInfo": "연락처 정보",
    "organization.phone": "전화번호",
    "organization.email": "이메일",
    "organization.website": "웹사이트",
    "organization.socialMedia": "소셜 미디어",
    "organization.publicFeed": "공개 피드",
    "organization.communityMedia": "커뮤니티 및 미디어",
    "organization.profile": "단체 프로필",
    "organization.loadError": "단체 프로필을 불러오지 못했습니다",
    "organization.saveError": "단체 프로필 저장에 실패했습니다",
    "common.remove": "삭제",
    "common.saveChanges": "변경 사항 저장",
    "dashboard.thisMonth": "이번 달",
    "dashboard.verified": "인증된 봉사자",
    "dashboard.hoursLogged": "기록된 시간",
    "dashboard.endorsements": "추천",
    "dashboard.organizationsHelped": "지원한 단체",
    "dashboard.yourOrganizationsHelped": "내가 지원한 단체",
    "transactions.createCampaign": "첫 캠페인 만들기",
    "contributions.emptyTitle": "나눔의 여정은 여기서 시작됩니다",
    "contributions.browseCharities": "자선단체 찾기",
    "charity.profile.verified501c3": "인증된 비영리단체",
    "charity.profile.verified501c3Tooltip":
      "등록된 501(c)(3) — 미국에서 기부금이 세금 공제 대상이 될 수 있습니다",
    "charity.profile.statusClaimed": "인수됨",
    "charity.profile.statusUnclaimed": "미인수 — 공공 등록 데이터만 제공",
    "charity.profile.statusIrsVerified": "IRS 인증 비영리단체",
    "charity.profile.requestWidget.unclaimedBody":
      "이 단체는 아직 Give Protocol에서 프로필을 인수하지 않았습니다. 단체가 프로필을 인수하고 지갑 설정을 완료하면 기부할 수 있습니다.",
    "charity.profile.rowEin": "납세자 번호",
    "charity.profile.rowName": "이름",
    "charity.profile.rowLocation": "위치",
    "charity.profile.rowRulingYear": "등록 연도",
    "charity.profile.rowNteeCode": "부문 코드",
    "charity.profile.rowDeductibility": "세금 공제 가능 여부",
    "charity.profile.rowAffiliation": "소속",
    "charity.profile.rowClassification": "분류",
    "charity.profile.rowFoundation": "재단 유형",
    "charity.profile.rowActivityCodes": "활동 코드",
    "charity.profile.rowOrgType": "단체 유형",
    "charity.profile.rowSubsection": "하위 조항",
    "charity.profile.rowStatus": "상태",
    "charity.profile.registryRecord": "등록 공개 기록",
    "charity.profile.einDisplay": "납세자 번호",
    "charity.profile.charityNotFoundByTaxId":
      "이 납세자 번호로 등록된 자선단체를 찾을 수 없습니다.",
    "charity.profile.registeredNonprofit": "등록된 비영리단체",
    "charity.profile.registeredYear": "{{year}}년 등록",
    "charity.profile.shareAria": "공유",
    "charity.profile.copied": "복사되었습니다!",
    "charity.profile.about": "소개",
    "charity.profile.claimProfile": "이 프로필 인수하기",
    "charity.profile.noDescription": "설명이 없습니다.",
    "charity.profile.toAddOne": "에서 추가하세요.",
    "charity.profile.contact": "연락처",
    "charity.profile.donate.support": "후원하기",
    "charity.profile.donate.walletUnset":
      "이 단체는 아직 공식 수신 지갑을 설정하지 않았습니다.",
    "charity.profile.donate.walletPending":
      "이 단체는 지갑 설정을 완료하는 중입니다 — 기부가 일시적으로 불가합니다.",
    "charity.profile.donate.walletLegacy":
      "이 단체는 레거시 지갑 주소를 사용하고 있습니다.",
    "charity.profile.donate.feeNote":
      "직접 기부에 대한 플랫폼 수수료 0%. 네트워크 수수료 적용.",
    "charity.profile.donate.jurisdictionUnavailable":
      "미국 외 자선 단체에 대한 기부는 Give Protocol에서 아직 지원되지 않습니다.",
    "portfolio.title": "포트폴리오 펀드",
    "settings.displayPreferences": "디스플레이 설정",
    "settings.theme": "테마",
    "settings.light": "라이트",
    "settings.dark": "다크",
    "auth.toast.welcomeBack": "Welcome back, {{firstName}}",
    "auth.toast.youreSignedIn": "You're signed in.",
    "auth.toast.walletConnected": "Wallet connected",
    "auth.toast.signedInWith": "Signed in with {{address}}.",
    "auth.toast.signedOut": "Signed out",
    "auth.toast.signInFailed": "Sign-in failed",
    "auth.toast.signOutFailed": "Sign-out failed",
    "donation.toast.received": "Donation received",
    "donation.toast.receivedMessage":
      "Thank you — your tax receipt is on the way.",
    "donation.toast.submitted": "Transaction submitted",
    "donation.toast.submittedMessage": "Waiting for on-chain confirmation…",
    "donation.toast.confirmed": "Donation confirmed",
    "donation.toast.confirmedMessage":
      "Your contribution is recorded on-chain.",
    "donation.toast.failed": "Donation failed",

    // Art. 9(2)(a) donation consent (GIV-655)
    "donation.art9Consent.statement":
      "제 기부 기록이 저를 {{charity}}에 연결한다는 것을 이해합니다. 이것이 종교적, 정치적 또는 철학적 소속을 나타낼 수 있는 경우, 기부를 완료하고 관리하기 위해 Give Protocol이 이 기록을 처리하는 것에 명시적으로 동의합니다.",
    "donation.art9Consent.label": "기부 데이터 동의",
    "donation.art9Consent.required":
      "계속하려면 기부 데이터 처리에 동의해야 합니다.",

    "charity.toast.verificationEmailSent": "Verification email sent",
    "charity.toast.verificationEmailMessage":
      "Check your inbox — the link expires in 24 hours.",
    "charity.toast.submissionFailed": "Submission failed",

    "privacy.security.auditLog":
      "GDPR 제32조에 따른 기술적 조치로서, 당사는 개인 데이터에 대한 관리자 접근을 기록하고 모니터링합니다. 여기에는 수행된 작업과 발생 시점이 포함되며, 무단 접근 탐지, 책임성 입증, 그리고 만일의 개인 데이터 침해(제34조) 발생 시 사건 재구성을 목적으로 합니다. 기부자의 개인 데이터는 이러한 관리자 접근 로그에 복제되지 않습니다. 관리자 접근 로그는 §7.1에 설명된 인증 및 보안 로그와 구별되며, 보존 기간은 당사의 내부 처리 활동 기록에 의해 관리됩니다.",

    // Remaining i18n keys — batch translation
    "admin.auditTrail.filterByAction": "작업별 필터",
    "admin.auditTrail.allActions": "모든 작업",
    "admin.auditTrail.action.charityStatusChange": "자선단체 상태 변경",
    "admin.auditTrail.action.userStatusChange": "사용자 상태 변경",
    "admin.auditTrail.action.donationFlag": "기부 플래그 지정",
    "admin.auditTrail.action.donationFlagResolve": "기부 플래그 해제",
    "admin.auditTrail.action.validationOverride": "검증 재정의",
    "admin.auditTrail.action.configChange": "설정 변경",
    "admin.auditTrail.action.verificationApprove": "인증 승인",
    "admin.auditTrail.action.verificationReject": "인증 거부",
    "admin.auditTrail.action.charitySuspend": "자선단체 정지",
    "admin.auditTrail.action.charityReinstate": "자선단체 복원",
    "admin.auditTrail.action.userSuspend": "사용자 정지",
    "admin.auditTrail.action.userReinstate": "사용자 복원",
    "admin.auditTrail.action.userBan": "사용자 차단",
    "admin.auditTrail.action.viewPii": "PII 조회",
    "admin.auditTrail.action.viewPiiList": "PII 목록 조회",
    "admin.auditTrail.viewedEntity":
      "관리자 {{adminId}}가 {{entityType}} {{entityId}}을(를) 조회했습니다",
    "admin.auditTrail.viewedList":
      "관리자 {{adminId}}가 {{entityType}} 목록을 조회했습니다 (페이지 {{page}}, 필터: {{filters}})",
    "admin.auditTrail.viewedListNoFilters":
      "관리자 {{adminId}}가 {{entityType}} 목록을 조회했습니다 (페이지 {{page}})",
    "admin.actions.platformNews": "플랫폼 뉴스",
    "admin.actions.platformNewsDesc": "찾아보기 페이지의 뉴스 항목 관리",
    "admin.news.activate": "{{title}} 게시",
    "admin.news.activated": "뉴스 항목이 게시되었습니다",
    "admin.news.activeLabel": "게시됨 (공개 표시)",
    "admin.news.categoryLabel": "카테고리",
    "admin.news.contentLabel": "내용 / 발췌문",
    "admin.news.contentPlaceholder": "뉴스 항목에 대한 간단한 설명...",
    "admin.news.createNews": "뉴스 항목 만들기",
    "admin.news.createNewsBtn": "뉴스 만들기",
    "admin.news.created": "뉴스 항목이 생성되었습니다",
    "admin.news.dateLabel": "게시일",
    "admin.news.deactivate": "{{title}} 게시 중지",
    "admin.news.deactivated": "뉴스 항목이 숨겨졌습니다",
    "admin.news.deleteItem": "{{title}} 삭제",
    "admin.news.deleted": "뉴스 항목이 삭제되었습니다",
    "admin.news.editItem": "{{title}} 편집",
    "admin.news.editNews": "뉴스 항목 편집",
    "admin.news.imageLabel": "이미지 URL (선택 사항)",
    "admin.news.imagePlaceholder": "https://...",
    "admin.news.inactive": "비활성",
    "admin.news.newItem": "새 항목",
    "admin.news.noItemsMessage":
      "첫 번째 뉴스 항목을 만들어 커뮤니티에 소식을 전해보세요",
    "admin.news.noItemsYet": "아직 뉴스 항목이 없습니다",
    "admin.news.publishedOn": "{{date}}에 게시됨",
    "admin.news.saving": "저장 중...",
    "admin.news.subtitle": "공개 찾아보기 페이지에 표시되는 뉴스 항목 관리",
    "admin.news.title": "플랫폼 뉴스",
    "admin.news.titleLabel": "제목",
    "admin.news.titlePlaceholder": "예: 분기별 임팩트 보고서",
    "admin.news.updateNews": "뉴스 업데이트",
    "admin.news.updated": "뉴스 항목이 업데이트되었습니다",
    "admin.news.urlLabel": "링크 URL",
    "admin.news.urlPlaceholder": "https://example.org/article",
    "charity.walletBadge.institutionalLabel": "{{custodianName}}에 보관됨",
    "charity.walletBadge.institutionalTooltip":
      "기부금은 공인된 기관 수탁기관이 관리하는 지갑으로 전달됩니다.",
    "charity.walletBadge.safeLabel":
      "멀티시그 트레저리 · {{threshold}}/{{count}} 서명자",
    "charity.walletBadge.safeTooltip":
      "기부금은 자금 이동 전 여러 승인이 필요한 다중 서명 지갑으로 전달됩니다.",
    "wallet.eoa.chain": "네트워크",
    "wallet.eoa.checkAuthorized":
      "본인은 자선단체를 대신하여 이 지갑을 기부금 수령 주소로 지정할 권한이 있음을 확인합니다.",
    "wallet.eoa.checkRisk":
      "단일 서명자 지갑은 멀티시그보다 위험이 높으며, 개인 키를 분실하면 자금을 영구적으로 잃게 된다는 것을 이해합니다.",
    "wallet.eoa.confirmSubtitle":
      "이 지갑을 등록하기 전에 다음 사항을 확인해 주세요.",
    "wallet.eoa.confirmTitle": "최종 확인",
    "wallet.eoa.connectFirst": "먼저 지갑을 연결해 주세요.",
    "wallet.eoa.connectWallet": "지갑 연결",
    "wallet.eoa.missingSignature":
      "서명이 누락되었습니다. 돌아가서 다시 서명해 주세요.",
    "wallet.eoa.proceedAnyway": "이해했으며 계속 진행합니다",
    "wallet.eoa.register": "지갑 등록",
    "wallet.eoa.registering": "등록 중...",
    "wallet.eoa.rejected": "서명 요청이 거부되었습니다.",
    "wallet.eoa.riskParagraph1":
      "단일 서명자(EOA) 지갑은 하나의 개인 키로 제어됩니다. 이 키를 분실, 도난 또는 침해당하면 이 지갑으로 전송된 모든 자금을 영구적으로 복구할 수 없습니다.",
    "wallet.eoa.riskParagraph2":
      "조직 자금의 경우, 대신 멀티시그 Safe 지갑을 사용할 것을 강력히 권장합니다. 멀티시그 지갑은 모든 거래에 여러 승인을 요구하여 단일 장애 지점을 방지합니다.",
    "wallet.eoa.riskParagraph3":
      "계속 진행함으로써, 개인 키의 침해, 분실 또는 부적절한 관리로 인한 자금 손실에 대해 Give Protocol이 책임지지 않는다는 점에 동의합니다.",
    "wallet.eoa.riskTitle": "단일 서명자 지갑: 중요한 위험 사항",
    "wallet.eoa.signError": "메시지 서명에 실패했습니다. 다시 시도해 주세요.",
    "wallet.eoa.signMessage": "확인 메시지 서명",
    "wallet.eoa.signSubtitle":
      "지갑을 연결하고 이 주소를 소유하고 있음을 증명하기 위해 메시지에 서명하세요.",
    "wallet.eoa.signTitle": "연결 및 서명",
    "wallet.eoa.useMultisig": "대신 멀티시그 사용",
    "wallet.eoa.walletConnection": "지갑",
    "wallet.eoa.walletToRegister": "등록할 지갑",
    "wallet.institutional.address": "지갑 주소",
    "wallet.institutional.attestation": "증명 문서",
    "wallet.institutional.attestationHelp":
      "수탁 관계를 증명하는 PDF, JPEG 또는 PNG 파일을 업로드하세요 (최대 10MB).",
    "wallet.institutional.backToWallets": "지갑 목록으로 돌아가기",
    "wallet.institutional.chain": "네트워크",
    "wallet.institutional.chooseFile": "파일 선택 또는 드래그 앤 드롭",
    "wallet.institutional.custodian": "수탁기관",
    "wallet.institutional.fileTooLarge": "파일 크기는 10MB 미만이어야 합니다.",
    "wallet.institutional.invalidAddress":
      "유효한 이더리움 주소를 입력해 주세요 (0x...)",
    "wallet.institutional.invalidFileType":
      "PDF, JPEG 또는 PNG 파일을 업로드해 주세요.",
    "wallet.institutional.removeFile": "파일 제거",
    "wallet.institutional.selectCustodian": "수탁기관을 선택해 주세요.",
    "wallet.institutional.selectCustodianOption": "수탁기관 선택...",
    "wallet.institutional.submit": "검토용 제출",
    "wallet.institutional.submittedDesc":
      "기관 수탁 지갑 등록이 검토 중입니다. 영업일 기준 3일 이내에 이메일을 받으실 수 있습니다.",
    "wallet.institutional.submittedTitle": "지갑이 검토용으로 제출되었습니다",
    "wallet.institutional.submitting": "제출 중...",
    "wallet.institutional.subtitle":
      "수탁기관이 관리하는 지갑 정보를 제공하고 검증을 위해 증명 문서를 업로드하세요.",
    "wallet.institutional.title": "기관 수탁 지갑 등록",
    "wallet.institutional.uploadFile": "증명 파일 업로드",
    "wallet.institutional.uploadRequired": "증명 문서를 업로드해 주세요.",
    "wallet.safe.address": "Safe 주소",
    "wallet.safe.chain": "네트워크",
    "wallet.safe.connectFirst": "먼저 서명자 지갑을 연결해 주세요.",
    "wallet.safe.connectSigner": "서명자 지갑 연결",
    "wallet.safe.createNew": "새 Safe 만들기",
    "wallet.safe.createNewDesc":
      "app.safe.global을 열어 새 멀티시그를 만들 수 있습니다. 배포가 완료되면 이곳으로 돌아오세요.",
    "wallet.safe.haveOne": "이미 Safe가 있습니다",
    "wallet.safe.haveOneDesc":
      "Safe 주소를 입력하고 서명자 지갑으로 메시지에 서명하여 소유권을 확인하세요.",
    "wallet.safe.invalidAddress":
      "유효한 이더리움 주소를 입력해 주세요 (0x...)",
    "wallet.safe.rejected": "서명 요청이 거부되었습니다.",
    "wallet.safe.signError":
      "확인 메시지 서명에 실패했습니다. 다시 시도해 주세요.",
    "wallet.safe.signVerify": "서명하여 소유권 확인",
    "wallet.safe.signerWallet": "서명자 지갑",
    "wallet.safe.subtitle":
      "Safe는 모든 거래를 승인하기 위해 여러 서명자가 필요하며, 자선단체 자금에 최고 수준의 보안을 제공합니다.",
    "wallet.safe.title": "Safe 멀티시그 지갑 설정",
    "wallet.safe.verifyTitle": "Safe 소유권 확인",
    "wallet.safe.verifying": "확인 중...",
    "wallet.setup.addAnother": "추가",
    "wallet.setup.custodian": "수탁기관",
    "wallet.setup.deleteFailed": "지갑 제거에 실패했습니다",
    "wallet.setup.eoaDesc":
      "하나의 개인 키로 제어되는 표준 지갑입니다. 가장 간단하지만 조직 사용에는 보안성이 가장 낮습니다.",
    "wallet.setup.eoaTitle": "단일 서명자 (EOA)",
    "wallet.setup.institutionalDesc":
      "공인 수탁기관(Fireblocks, Anchorage 등)이 관리합니다. 증명 문서가 필요합니다.",
    "wallet.setup.institutionalTitle": "기관 수탁",
    "wallet.setup.makePrimary": "기본으로 설정",
    "wallet.setup.primary": "기본",
    "wallet.setup.primaryFailed": "기본 지갑 업데이트에 실패했습니다",
    "wallet.setup.primaryUpdated": "기본 지갑이 업데이트되었습니다",
    "wallet.setup.recommended": "권장",
    "wallet.setup.remove": "지갑 제거",
    "wallet.setup.safeDesc":
      "모든 거래에 여러 서명자가 필요합니다. 조직 자금에 최고 수준의 보안을 제공합니다.",
    "wallet.setup.safeSigners": "서명자",
    "wallet.setup.safeTitle": "멀티시그 Safe",
    "wallet.setup.subtitle":
      "자선단체가 암호화폐 기부금을 수령할 방법을 선택하세요. 최대 보안을 위해 멀티시그 지갑을 권장합니다.",
    "wallet.setup.title": "수령 지갑 설정",
    "wallet.setup.viewExplorer": "블록 탐색기에서 보기",
    "wallet.setup.walletAdded": "지갑이 성공적으로 등록되었습니다",
    "wallet.setup.walletDeleted": "지갑이 제거되었습니다",
    "wallet.setup.walletsTitle": "수령 지갑",
    "admin.nav.dashboard": "대시보드",
    "admin.nav.reports": "보고서 및 분석",
    "admin.nav.charities": "자선단체",
    "admin.nav.donations": "기부",
    "admin.nav.impactMetrics": "임팩트 지표",
    "admin.nav.portfolioFunds": "포트폴리오 펀드",
    "admin.nav.contentModeration": "콘텐츠 모더레이션",
    "admin.nav.settings": "시스템 설정",
    "admin.nav.overview": "개요",
    "admin.nav.operations": "운영",
    "admin.nav.consoleLabel": "관리자 콘솔",
    "admin.shell.searchPlaceholder": "기부자, 자선단체, 거래 해시 검색…",
    "admin.shell.searchLabel": "관리자 콘솔 검색",
    "admin.shell.notifications": "알림",
    "admin.shell.adminLabel": "관리자",
    "admin.shell.superAdmin": "최고 관리자",
    "admin.shell.signOut": "로그아웃",
    "admin.shell.backToPublicSite": "공개 사이트로 돌아가기",
    "admin.shell.homeLink": "Give Protocol 홈",
    "admin.dashboard.severityHigh": "높은 우선순위",
    "admin.dashboard.severityMedium": "주의 필요",
    "admin.dashboard.severityLow": "검토 대상",
    "admin.dashboard.alertOldest": "가장 오래된 요청 제출일",
    "admin.dashboard.alertReviewHint":
      "온보딩을 계속 진행하려면 검토가 필요합니다",
    "admin.dashboard.reviewQueue": "검토 대기열",
    "admin.dashboard.kpiDonorsSub": "최근 30일간 신규 {{count}}건",
    "admin.dashboard.kpiPending": "{{count}}건 대기 중",
    "admin.dashboard.awaitingVerification": "인증 대기 중",
    "admin.dashboard.kpiVerifiedSub": "전체 승인 {{total}}건 중",
    "admin.dashboard.kpiVolunteersActive": "활성 신청",
    "admin.dashboard.kpiVolunteersSub": "활성 신청 없음",
    "admin.dashboard.donationVolume": "기부 규모",
    "admin.dashboard.donationVolumeSub": "{{range}} · 암호화폐 + 법정화폐 합산",
    "admin.dashboard.range30d": "최근 30일",
    "admin.dashboard.range90d": "최근 90일",
    "admin.dashboard.rangeYtd": "연초 이후",
    "admin.dashboard.volumeEmptyTitle": "아직 기록된 기부가 없습니다",
    "admin.dashboard.volumeEmptySub":
      "첫 번째 기부가 정산되면 이곳에 규모가 표시됩니다",
    "admin.dashboard.totalVolume": "총 규모",
    "admin.dashboard.crypto": "암호화폐",
    "admin.dashboard.fiat": "법정화폐",
    "admin.dashboard.activitySubtitle": "실시간 플랫폼 이벤트",
    "admin.dashboard.viewAllActivity": "모든 활동 보기",
    "admin.dashboard.viewAllDonations": "모든 기부 보기",
    "admin.charity.tabAll": "전체",
    "admin.charity.review": "검토",
    "admin.charity.colOrganization": "단체",
    "admin.charity.colRaised": "모금액",
    "admin.charity.colSubmitted": "제출일",
    "admin.charity.searchAria": "자선단체 검색",
    "admin.charity.reviewTitle": "{{name}} 검토",
    "admin.charity.submittedRelative": "{{when}}에 제출됨",
    "admin.charity.contactEmail": "이메일",
    "admin.charity.contactPhone": "전화번호",
    "admin.charity.raisedUnavailable": "이용 가능한 모금 총액이 없습니다",
    "admin.error.title": "데이터 로드 오류",
    "admin.error.recentActivity": "최근 활동 로드 오류",
    "admin.error.alerts": "알림 로드 오류",
    "admin.error.donationVolume": "기부 규모 로드 오류",
    "donation.gas.estimating": "네트워크 수수료 산정 중…",
    "donation.gas.label": "예상 네트워크 수수료",
    "donation.gas.highGasWarning":
      "높은 가스비 경고: 예상 수수료는 {{usd}}로, 기부금의 {{pct}}에 해당합니다.",
    "donation.gas.highGasSuggestion":
      "더 큰 금액을 기부하거나 수수료가 낮은 체인으로 전환하는 것을 고려해 보세요.",
    "donation.gas.l2Hint":
      "더 낮은 수수료를 원하시면 {{chains}}을(를) 시도해 보세요.",
  },
};
